export default class InvestigatorDetailsController {
  constructor($q, $state, $scope, FileUploader, AuthenticationService, UIService, InvestigatorService, Investigador, Genero, Pais, InvestigadorTipoInvestigador, InvestigadorTipo, InvestigadorGrauAcademico, InvestigadorHValue, InvestigadorCitacao, InvestigadorContratacao, InvestigadorAtividade, InvestigadorParticipacaoGestao, InvestigadorEntradaSaida, InvestigadorInstituicao, InvestigadorGrupoInvestigacao, GrauAcademico, TipoParticipacaoGestao, Instituicao, Categoria, Publicacao, PublicacaoService, PublicacaoAutor, RevistaEquipaEditorial, EventoOrganizacao, ProjetoEquipa, ProdutoInvestigador, Formacao, OrientacaoInvestigador, ServicoParticipante, Painel, Network, InvestigadorTooltip, GrupoInvestigacao) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.FileUploader = FileUploader;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.InvestigatorService = InvestigatorService;
    this.loaded = false;

    this.Investigador = Investigador;
    this.Genero = Genero;
    this.Pais = Pais;
    this.InvestigadorTipoInvestigador = InvestigadorTipoInvestigador;
    this.InvestigadorTipo = InvestigadorTipo;
    this.InvestigadorGrauAcademico = InvestigadorGrauAcademico;
    this.InvestigadorHValue = InvestigadorHValue;
    this.InvestigadorCitacao = InvestigadorCitacao;
    this.InvestigadorContratacao = InvestigadorContratacao;
    this.InvestigadorAtividade = InvestigadorAtividade;
    this.InvestigadorParticipacaoGestao = InvestigadorParticipacaoGestao;
    this.InvestigadorEntradaSaida = InvestigadorEntradaSaida;
    this.InvestigadorInstituicao = InvestigadorInstituicao;
    this.InvestigadorGrupoInvestigacao = InvestigadorGrupoInvestigacao;
    this.GrauAcademico = GrauAcademico;
    this.TipoParticipacaoGestao = TipoParticipacaoGestao;
    this.Instituicao = Instituicao;
    this.Categoria = Categoria;
    this.Publicacao = Publicacao;
    this.PublicacaoService = PublicacaoService;
    this.PublicacaoAutor = PublicacaoAutor;
    this.RevistaEquipaEditorial = RevistaEquipaEditorial;
    this.EventoOrganizacao = EventoOrganizacao;
    this.ProjetoEquipa = ProjetoEquipa;
    this.ProdutoInvestigador = ProdutoInvestigador;
    this.Formacao = Formacao;
    this.OrientacaoInvestigador = OrientacaoInvestigador;
    this.ServicoParticipante = ServicoParticipante;
    this.Painel = Painel;
    this.Network = Network;
    this.InvestigadorTooltip = InvestigadorTooltip;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.showEstadosPanel = false;

    this.tooltips = [];
    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optTiposInvestigador = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.tiposInvestigador = null;
    this.tiposInvestigadorLoading = true;

    // Default opt state - populate later when we have all states
    this.optGrausAcademicos = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.grausAcademicos = null;
    this.grausAcademicosLoading = true;

    // Default opt state - populate later when we have all states
    this.optHValues = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.hValues = null;
    this.hValuesLoading = true;

    // Default opt state - populate later when we have all states
    this.optCitacoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.citacoes = null;
    this.citacoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optContratacoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.contratacoes = null;
    this.contratacoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optAtividades = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.atividades = null;
    this.atividadesLoading = true;

    // Default opt state - populate later when we have all states
    this.optParticipacaoGestao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.participacaoGestao = null;
    this.participacaoGestaoLoading = true;

    // Default opt state - populate later when we have all states
    this.optEntradasSaidas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.entradasSaidas = null;
    this.entradasSaidasLoading = true;

    // Default opt state - populate later when we have all states
    this.optInstituicoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.instituicoes = null;
    this.instituicoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optGruposInvestigacao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.gruposInvestigacao = null;
    this.gruposInvestigacaoLoading = true;


    // Default opt state - populate later when we have all states
    this.optPublicacoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "publicacao.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.publicacoes = null;
    this.publicacoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optRevistas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "revista.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.revistas = null;
    this.revistasLoading = true;

    // Default opt state - populate later when we have all states
    this.optEventos = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "evento.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.eventos = null;
    this.eventosLoading = true;

    // Default opt state - populate later when we have all states
    this.optProjetos = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "projeto.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.projetos = null;
    this.projetosLoading = true;

    // Default opt state - populate later when we have all states
    this.optProdutos = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "produto.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.produtos = null;
    this.produtosLoading = true;

    // Default opt state - populate later when we have all states
    this.optFormacoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.formacoes = null;
    this.formacoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optOrientacoes = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "orientacao.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.orientacoes = null;
    this.orientacoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optServicos = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "servico.id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.servicos = null;
    this.servicosLoading = true;

    // Default opt state - populate later when we have all states
    this.optPaineis = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.paineis = null;
    this.paineisLoading = true;

    // Default opt state - populate later when we have all states
    this.optNetworks = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 10,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.networks = null;
    this.networksLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Investigador.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'user', 'genero', 'nacionalidade', {
          relation: 'superiorHierarquico1',
          scope: {
            fields: ['id', 'nome']
          }
        }, {
          relation: 'superiorHierarquico2',
          scope: {
            fields: ['id', 'nome']
          }
        }]
      }
    }).$promise.then(res => {
      // For verification purposes
      this.data = {userId: res.userId};
      // Remove data that is not supposed to be there
      if (!this.canReadInformacaoPrivada()) {
        res.emailAlternativo = undefined;
        res.dataNascimento = undefined;
        res.genero = undefined;
        res.generoId = undefined;
        res.nacionalidadeId = undefined;
        res.nacionalidade = undefined;
        res.contactoTelefonico = undefined;
      } else {
        res.dataNascimento = moment.utc(res.dataNascimento);
      }
      this.data = res;

      this.getTiposInvestigadorForInvestigador();
      this.getGrausAcademicosForInvestigador();
      this.getHValuesForInvestigador();
      this.getCitacoesForInvestigador();
      this.getContratacoesForInvestigador();
      this.getAtividadesForInvestigador();
      this.getParticipacaoGestaoForInvestigador();
      this.getEntradasSaidasForInvestigador();
      this.getInstituicoesForInvestigador();
      this.getGruposInvestigacaoForInvestigador();
      this.getPublicacoesForInvestigador();
      this.getRevistasForInvestigador();
      this.getEventosForInvestigador();
      this.getProjetosForInvestigador();
      this.getProdutosForInvestigador();
      this.getFormacoesForInvestigador();
      this.getOrientacoesForInvestigador();
      this.getServicosForInvestigador();
      this.getPaineisForInvestigador();
      this.getNetworksForInvestigador();
      this.getTooltips();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.investigator.list');
      this.UI.addToast('Erro ao carregar investigador. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(superioresHierarquicos => {
      // Remove itself from being its own superior hierarquico
      superioresHierarquicos = superioresHierarquicos.filter(x => x.id !== this.data.id);
      superioresHierarquicos.sort((a, b) => a.nome.localeCompare(b.nome));
      this.Pais.find({
        filter: {
          where: {},
          order: 'ordem ASC'
        }
      }).$promise.then(nacionalidades => {
        this.Genero.find({
          filter: {
            where: {},
            order: 'designacao ASC'
          }
        }).$promise.then(generos => {
          wait.close();
          let options = {
            size: 'lg',
            template: require('./details.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
              $scope.label = "Editar Investigador";
              $scope.investigador = angular.copy(this.data);
              $scope.nacionalidades = nacionalidades;
              $scope.generos = generos;
              $scope.superioresHierarquicos = superioresHierarquicos;
              $scope.checkingSlug = false;
              $scope.dateOptions = {
                dataNascimento: {
                  format: 'DD/MM/YYYY',
                  maxDate: moment()
                }
              };

              $scope.auxNacionalidade = {
                selected: $scope.investigador.nacionalidade ? $scope.investigador.nacionalidade : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxGenero = {
                selected: $scope.investigador.genero ? $scope.investigador.genero : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxSuperiorHierarquico1 = {
                selected: $scope.investigador.superiorHierarquico1 ? $scope.investigador.superiorHierarquico1 : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxSuperiorHierarquico2 = {
                selected: $scope.investigador.superiorHierarquico2 ? $scope.investigador.superiorHierarquico2 : null,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              $scope.updateSlug = () => {
                $scope.investigador.slug = this.InvestigatorService.stringToSlug($scope.investigador.nomePreferido);
              };

              // ORCID ID stuff
              $scope.optOrcid = {
                valid: true, // If orcidId typed is valid
                used: false, // If orcidId is already used in the database
                db: true, // If orcidId was looked up in database
                pending: false // If it's waiting online response or not, just used to control OK button while waiting
              };

              // Check if OrcidId form entry has error, true - error, false - ok
              $scope.orcidIdFormError = () => {
                return (!$scope.optOrcid.valid || $scope.optOrcid.used || !$scope.optOrcid.db);
              };

              // Called when typing orciId
              // Checks if OrcidID is valid, then checks online data if it's already used and if not imports and assigns data,
              // blocking what was obtained and unblocking what wasn't
              $scope.onChangeOrcidId = () => {
                // If OrcidId is empty, we have to disable errors
                if (!$scope.investigador.orcidId || $scope.investigador.orcidId.length === 0) {
                  // Reset all other errors
                  $scope.optOrcid.valid = true;
                  $scope.optOrcid.used = false;
                  $scope.optOrcid.db = true;
                  return;
                }
                // Check if it's well constructed
                $scope.optOrcid.valid = this.InvestigatorService.isValidOrcidId($scope.investigador.orcidId);

                if ($scope.optOrcid.valid) {
                  // Check if ORCID ID is used by someone else already
                  $scope.optOrcid.pending = true;
                  this.InvestigatorService.isOrcidIdAlreadyUsed($scope.investigador.id, $scope.investigador.orcidId).then((used) => {
                    $scope.optOrcid.pending = false;
                    $scope.optOrcid.db = true;
                    // If it's used by someone else
                    $scope.optOrcid.used = used;
                  }).catch(error => {
                    console.log(error);
                    $scope.optOrcid.pending = false;
                    $scope.optOrcid.db = false;
                  });
                } else {
                  // Reset all other errors
                  $scope.optOrcid.used = false;
                  $scope.optOrcid.db = true;
                }
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.ok = () => {
                let valid = true;
                if (!this.InvestigatorService.isValidOrcidId($scope.investigador.orcidId)) {
                  valid = false;
                  this.UI.addToast("Orcid ID inválido.");
                }
                if ($scope.investigador.emailAlternativo && !this.InvestigatorService.validEmail($scope.investigador.emailAlternativo)) {
                  valid = false;
                  this.UI.addToast("Email Alternativo inválido.");
                }
                if ($scope.investigador.website && !this.InvestigatorService.isValidURL($scope.investigador.website)) {
                  valid = false;
                  this.UI.addToast("Website deve ser um URL válido");
                }
                if (!this.InvestigatorService.isValidSlug($scope.investigador.slug)) {
                  valid = false;
                  this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
                }

                if ($scope.auxSuperiorHierarquico1.selected && $scope.auxSuperiorHierarquico2.selected && $scope.auxSuperiorHierarquico1.selected.id === $scope.auxSuperiorHierarquico2.selected.id) {
                  valid = false;
                  this.UI.addToast("Por favor escolha superiores hierárquicos distintos");
                }

                // Only check slug if we have valid until now otherwise it's
                if (valid) {
                  // Check if slug exists
                  $scope.checkingSlug = true;
                  let wait = this.UI.showWaiting();
                  this.InvestigatorService.checkExistingSlug($scope.investigador.slug, this.data.id).then((exists) => {
                    $scope.checkingSlug = false;
                    if (exists) {
                      this.UI.addToast("Este slug já existe para outro investigador");
                      valid = false;
                      wait.close();
                    } else {
                      valid = true;
                    }

                    if (valid) {
                      // Check again for ORCID ID
                      $scope.optOrcid.pending = true;

                      this.InvestigatorService.isOrcidIdAlreadyUsed($scope.investigador.id, $scope.investigador.orcidId).then((used) => {
                        wait.close();
                        $scope.optOrcid.pending = false;
                        $scope.optOrcid.db = true;
                        // If it's used by someone else
                        $scope.optOrcid.used = used;
                        if (!used) { // We can safely close it
                          $scope.$close($scope);
                        }
                      }).catch(error => {
                        wait.close();
                        console.log(error);
                        $scope.optOrcid.pending = false;
                        $scope.optOrcid.db = false;
                      });
                    }
                  }).catch(err => {
                    $scope.checkingSlug = false;
                    wait.close();
                    this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
                    console.log(err);
                  });
                }
              };

              $scope.cancel = () => $scope.$dismiss('cancel');
            }]
          };

          this.UI.showDialog(options).then(res => {
            this.loaded = false;
            if (res) {
              if (res.investigador.descricao !== 0 && !res.investigador.descricao)
                res.investigador.descricao = null;
              this.data.nomePreferido = res.investigador.nomePreferido;
              this.data.slug = res.investigador.slug;
              this.data.descricao = res.investigador.descricao;
              this.data.dataNascimento = res.investigador.dataNascimento.format();
              this.data.email = res.investigador.email;
              this.data.emailAlternativo = res.investigador.emailAlternativo;
              this.data.contactoTelefonico = res.investigador.contactoTelefonico;
              this.data.orcidId = res.investigador.orcidId;
              this.data.cienciaId = res.investigador.cienciaId;
              this.data.scopusId = res.investigador.scopusId;
              this.data.chavePublicaFct = res.investigador.chavePublicaFct;
              this.data.genero = res.auxGenero.selected;
              this.data.generoId = res.auxGenero.selected.id;
              this.data.nacionalidade = res.auxNacionalidade.selected;
              this.data.nacionalidadeId = res.auxNacionalidade.selected.id;
              this.data.observacoes = res.investigador.observacoes ? res.investigador.observacoes : null;
              this.data.contactoInterno = res.investigador.contactoInterno || null;
              this.data.website = res.investigador.website || null;
              this.data.gabinete = res.investigador.gabinete || null;

              this.data.superiorHierarquico1 = res.auxSuperiorHierarquico1.selected ? res.auxSuperiorHierarquico1.selected : null;
              this.data.superiorHierarquico1Id = res.auxSuperiorHierarquico1.selected ? res.auxSuperiorHierarquico1.selected.id : null;
              this.data.superiorHierarquico2 = res.auxSuperiorHierarquico2.selected ? res.auxSuperiorHierarquico2.selected : null;
              this.data.superiorHierarquico2Id = res.auxSuperiorHierarquico2.selected ? res.auxSuperiorHierarquico2.selected.id : null;

              this.data.atualizadoPorId = this.user.id;
              this.data.dataAtualizacao = moment().format();

              this.Investigador.upsert(this.data).$promise.then((res) => {
                this.InvestigatorService.checkValidity(this.data.id).then(ok => {
                  this.UI.addToast("Dados atualizados com sucesso");
                  this.loadData();
                }).catch(error => {
                  console.log(error);
                  this.UI.addToast("Erro ao atualizar investigador - validação. Verifique a ligação");
                });
              }).catch((error) => {
                console.log(error);
                this.UI.showAlert("Erro ao atualizar investigador. Verifique a ligação");
                this.loaded = true;
              });
            }
          });
        }).catch(err => {
          wait.close();
          console.log(err);
          this.UI.addToast("Não foi possível ler Géneros. Verifique a ligação");
        });
      }).catch(err => {
        wait.close();
        console.log(err);
        this.UI.addToast("Não foi possível ler Nacionalidades. Verifique a ligação");
      });
    }).catch(err => {
      wait.close();
      console.log(err);
      this.UI.addToast("Não foi possível ler Superiores Hierárquicos. Verifique a ligação");
    });
  };

  editInformacao = () => {
    let options = {
      size: 'lg',
      template: require('./informacao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Adicional";
        $scope.investigador = angular.copy(this.data);

        $scope.ok = () => {
          if ($scope.investigador.researcherId && !this.InvestigatorService.isValidURL($scope.investigador.researcherId)) {
            this.UI.addToast("ResearcherID deve ser um URL válido");
            return;
          }
          if ($scope.investigador.googleScholar && !this.InvestigatorService.isValidURL($scope.investigador.googleScholar)) {
            this.UI.addToast("Google Scholar deve ser um URL válido");
            return;
          }
          if ($scope.investigador.degois && !this.InvestigatorService.isValidURL($scope.investigador.degois)) {
            this.UI.addToast("Degóis deve ser um URL válido");
            return;
          }
          $scope.$close($scope.investigador);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;

      this.data.researcherId = ok.researcherId || null;
      this.data.googleScholar = ok.googleScholar || null;
      this.data.degois = ok.degois || null;

      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Investigador.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Informações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar investigador. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  editIdentificadores = () => {
    let options = {
      size: 'lg',
      template: require('./identificadores.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Outros Identificadores Académicos / Científicos";
        $scope.investigador = angular.copy(this.data);

        $scope.ok = () => {
          if ($scope.investigador.researcherId && !this.InvestigatorService.isValidURL($scope.investigador.researcherId)) {
            this.UI.addToast("ResearcherID deve ser um URL válido");
            return;
          }
          if ($scope.investigador.googleScholar && !this.InvestigatorService.isValidURL($scope.investigador.googleScholar)) {
            this.UI.addToast("Google Scholar deve ser um URL válido");
            return;
          }
          if ($scope.investigador.degois && !this.InvestigatorService.isValidURL($scope.investigador.degois)) {
            this.UI.addToast("Degóis deve ser um URL válido");
            return;
          }
          $scope.$close($scope.investigador);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      this.data.cienciaId = ok.cienciaId || null;
      this.data.scopusId = ok.scopusId || null;
      this.data.chavePublicaFct = ok.chavePublicaFct || null;
      this.data.researcherId = ok.researcherId || null;
      this.data.googleScholar = ok.googleScholar || null;
      this.data.degois = ok.degois || null;

      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Investigador.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Informações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar investigador. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  generateUUID = () => {
    let uuid = "", i, random;
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0;
      if (i == 8 || i == 12 || i == 16 || i == 20) {
        uuid += "-";
      }
      uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
  };

  addImage = () => {
    let options = {
      size: 'lg',
      template: require('./images.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.images = {};
        $scope.label = "Editar imagem de investigador ISR";
        $scope.newFileName = '';
        $scope.oldFileName = '';

        $scope.uuid = this.generateUUID();

        $scope.uploader = new this.FileUploader({
          url: '/api/Upload/investigadores/upload',
          queueLimit: 1,
          formData: [
            {
              key: 'value'
            }
          ]
        });

        let filter = {
          name: 'verifyIMG',
          fn: function (item, options) {
            return item.type.indexOf("image/") !== -1;
          }
        };
        $scope.uploader.filters.push(filter);

        $scope.uploader.onAfterAddingFile = (item) => {
          let partes = item.file.name.split(".");
          $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];

          if ($scope.uploader.queue.length > 1)
            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
          $scope.oldFileName =  $scope.uploader.queue[0].file.name;
        };

        $scope.uploader.onWhenAddingFileFailed = (img) => {
          this.UI.addToast("Por favor, carregue uma imagem");
        };

        $scope.uploader.onErrorItem = (response, status, headers) => {
          this.UI.addToast("A imagem não foi carregada com sucesso");
        };

        $scope.uploader.onBeforeUploadItem = (item) => {
          item.file.name = $scope.newFileName;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };

    let dialogCreate = this.UI.showDialog(options);

    dialogCreate.then((ok) => {
      if (ok.newFileName) {
        let wait = this.UI.showWaiting();
        this.Investigador.deleteFoto({id: this.data.id}).$promise.then(() => { // Delete previous
          this.Investigador.prototype$updateAttributes({id: this.data.id}, {foto: ok.newFileName}).$promise.then(() => {
            if (ok.newFileName) {
              // File exists, upload it
              ok.uploader.uploadAll();
              this.loadData();
            } else {
              // No file, just update the list
              this.loadData();
            }
            wait.close();
            this.UI.addToast("Imagem adicionada com sucesso!");
          }).catch(err => {
            wait.close();
            this.UI.addToast("Erro a adicionar imagem.");
            console.log(err);
          });
        }).catch(error => {
          console.log(error);
          this.UI.addToast("Erro na substituição de imagem.");
        });
      }
    }).catch((error) => {
      if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
        console.log(error);
    });
  };

  confirmDeleteFoto = () => {
    let title = "Eliminar Foto de Investigador";
    let warning = "Tem a certeza que pretende remover esta foto de investigador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.deleteFoto();
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    });
  };

  deleteFoto = () => {
    this.Investigador.findById({id : this.data.id}).$promise.then((res) => {
      if (res) {
        if (res.foto) {
          this.Investigador.deleteFoto({id: this.data.id}).$promise.then(() => {
            this.UI.addToast("Foto removida com sucesso");
            this.loadData();
          }).catch(error => {
            console.log(error);
            this.UI.showAlert("Erro na remoção de foto. Verifique se tem permissões e/ou verifique a ligação");
          });
        } else {
          this.UI.addToast("Investigador sem foto definida");
          this.loadData();
        }
      } else {
        this.UI.addToast("Investigador não encontrado. Verifique a ligação");
        this.loadData();
      }
    }).catch((error) => {
      console.log(error);
    });
  };


  // Publicacoes

  importPublicacoes = () => {
    // Vars from directory function
    let orcidId = this.data.orcidId;
    let nome = this.data.nome;

    if (!this.InvestigatorService.isValidOrcidId(orcidId)) {
      this.UI.addToast("ORCID ID do investigador inválido");
      return;
    }
    let wait = this.UI.showWaiting();
    this.Publicacao.getPublicacoesByOrcidId({orcidId: orcidId}).$promise.then((data) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./../directory/import.publicacoes.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.title = "Importar Publicações" + (nome ? ` - ${nome}` : '');
          scope.publicacoes = data.data;
          scope.allSelected = false;


          scope.selectAll = () => {
            scope.allSelected = !scope.allSelected;
            if (scope.allSelected) {
              for (let i = 0; i < scope.publicacoes.length; i++) {
                scope.publicacoes[i].importing = true;
              }
            } else {
              for (let i = 0; i < scope.publicacoes.length; i++) {
                scope.publicacoes[i].importing = false;
              }
            }
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      };

      let modal = this.UI.showDialog(options);

      modal.then((res) => {
        let importing = res.publicacoes.filter(x => x.importing);
        importing = importing.map(x => {return {orcidBaseId: x.orcidBaseId, putCode: x.putCode, doiShort: x.doiShort, titulo: x.titulo};});
        if (importing.length > 0) {
          wait = this.UI.showWaiting();
          this.Publicacao.importPublicacoes({data: importing}).$promise.then(data => {
            wait.close();
            if (data.errors && data.errors.length > 0) { // Errors happened, show details
              let total = importing.length;
              let numErros = data.errors.filter(x => x.error === true).length;
              let numWarnings = data.errors.filter(x => x.error === false).length;
              let ok = total - numErros - numWarnings;

              let title = `Importação - ${total} Publicaç${total === 1 ? 'ão' : 'ões'} - ${numWarnings} aviso${numWarnings === 1 ? '' : 's'}, ${numErros} erro${numErros === 1 ? '' : 's'}`;
              let introText = `Fo${ok === 1 ? 'i' : 'ram'} importada${ok === 1 ? '' : 's'} ${ok} publicaç${ok === 1 ? 'ão' : 'ões'} com sucesso, tendo ocorrido ${data.errors.length} erro${data.errors.length === 1 ? '' : 's'}:`;
              let instance = this.UI.showDialog({
                size: 'md',
                template: require('../../interface/modals/show-list.html'),
                controller: ['$scope', ($scope) => {
                  $scope.title = title;
                  $scope.introText = introText;
                  $scope.list = data.errors;
                  $scope.ok = function () {
                    $scope.$close();
                  };
                }]
              });
              instance.finally(() => {
                // Nothing should happen, just reload
                this.loadData();
              });
            } else { // No errors were found, just show message
              let okString = (importing.length === 1 ? (`1 publicação importada com sucesso`) : (`${importing.length} publicações importadas com sucesso`));
              let alert = this.UI.showAlert(okString);
              alert.finally(() => {
                this.loadData();
              });
            }
          }).catch(error => {
            console.log(error);
            this.UI.addToast("Erro de importação. Por favor tente novamente");
          });
        } else {
          this.UI.addToast("Nada a importar");
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível obter publicações. Verifique a ligação");
    })
  };


  // Multiple data
  // Entradas / Saídas
  entradasSaidasModalOptions = (data, edit) => {
    let entradaSaida = {};
    if (edit && data != null) {
      entradaSaida = angular.copy(data);
    }
    return {
      size: 'lg',
      template: require('./../new/edit.entrada.saida.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.label = (edit ? "Editar" : "Nova") + " Movimentação";
        scope.entradaSaida = entradaSaida;
        scope.removeDate = this.UI.removeDate;
        scope.dateOptions = {
          dataEntrada: {format: 'DD/MM/YYYY'},
          dataSaida: {format: 'DD/MM/YYYY'}
        };

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };
  };

  // Adicionar uma nova entrada/saída para investigador
  addEntradaSaida = () => {
    let options = this.entradasSaidasModalOptions(null, false);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.entradaSaida) {
        this.entradasSaidasLoading = true;
        let item = angular.copy(ok.entradaSaida);
        item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
        if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
          item.dataSaida = item.dataSaida.format(); // Use text instead of moment
        else
          item.dataSaida = null;

        this.InvestigatorService.createMultipleData(this.InvestigadorEntradaSaida, [item], this.id, 'investigadorId').then((ok) => {
          this.data.ok = ok.ok;
          this.UI.addToast("Movimentação criada com sucesso");
          this.getEntradasSaidasForInvestigador();
        }).catch(error => {
          this.entradasSaidasLoading = false;
          this.UI.addToast("Erro ao inserir movimentação. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Edita informação de entrada/saída para investigador
  editEntradaSaida = (x) => {
    let options = this.entradasSaidasModalOptions(x, true);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.entradaSaida) {
        this.entradasSaidasLoading = true;
        // Update data without replacing the variable e (so it's still an element of the array)
        x.dataEntrada = ok.entradaSaida.dataEntrada.format(); // Use text instead of moment
        if (ok.entradaSaida.dataSaida != null && ok.entradaSaida.dataSaida.isValid())
          x.dataSaida = ok.entradaSaida.dataSaida.format(); // Use text instead of moment
        else
          x.dataSaida = null;
        x.observacoes = ok.entradaSaida.observacoes;

        this.InvestigatorService.updateMultipleData(this.InvestigadorEntradaSaida, [x]).then((res) => {
          this.UI.addToast("Movimentação atualizada com sucesso");
          this.getEntradasSaidasForInvestigador();
        }).catch((error) => {
          this.entradasSaidasLoading = false;
          this.UI.addToast("Erro ao atualizar movimentação. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteEntradaSaida = (x) => {
    let title = "Eliminar Movimentação";
    let warning = "Tem a certeza que pretende remover esta movimentação?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeEntradaSaida(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeEntradaSaida = (x) => {
    this.entradasSaidasLoading = true;
    // Find again entrada/saida to delete, so we can update it
    this.InvestigadorEntradaSaida.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((entradaSaidaToRemove) => {
      // Only for mandatory existing multiple data
      this.InvestigadorEntradaSaida.count({
        fields: {id: true},
        where: {
          investigadorId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other entradas/saidas still remaining

          // Remove data
          this.InvestigadorEntradaSaida.deleteById({
            id: entradaSaidaToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Movimentação removida com sucesso");
            this.getEntradasSaidasForInvestigador();
          });

        } else { // No other entradas/saidas exist, can't remove
          this.entradasSaidasLoading = false;
          this.UI.showAlert("Não foi possível apagar o registo de movimentação porque tem que haver pelo menos 1 registo para o investigador");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar movimentações. Verifique a ligação");
        this.getEntradasSaidasForInvestigador();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar movimentação. Verifique se ainda existe.");
      this.getEntradasSaidasForInvestigador();
    });
  };

  getEntradasSaidasForInvestigador = () => {
    this.entradasSaidasLoading = true;
    let whereLiteral = {
      'InvestigadorEntradaSaida.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optEntradasSaidas.filter).forEach(f => {
      if (this.optEntradasSaidas.filter[f])
        where[f] = this.optEntradasSaidas.filter[f];
    });
    this.InvestigadorEntradaSaida.table({
      params: {
        fields: [
          'InvestigadorEntradaSaida.id as id',
          'InvestigadorEntradaSaida.investigadorId as investigadorId',
          'InvestigadorEntradaSaida.dataEntrada as dataEntrada',
          'InvestigadorEntradaSaida.dataSaida as dataSaida',
          'InvestigadorEntradaSaida.criadoPorId as criadoPorId',
          'InvestigadorEntradaSaida.dataCriacao as dataCriacao',
          'InvestigadorEntradaSaida.atualizadoa as atualizadoa',
          'InvestigadorEntradaSaida.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName'
        ],
        from: ['InvestigadorEntradaSaida', 'User', 'User'],
        references: [undefined, 'InvestigadorEntradaSaida.criadoPorId', 'InvestigadorEntradaSaida.atualizadoPorId'],
        aliases: [null, null, 'User2'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optEntradasSaidas.order,
        sort: this.optEntradasSaidas.sort,
        limit: this.optEntradasSaidas.items,
        skip: (this.optEntradasSaidas.page - 1) * this.optEntradasSaidas.items,
      }
    }).$promise.then(res => {
      let page = this.optEntradasSaidas.page;
      let items = this.optEntradasSaidas.items;

      let total = res.count;

      this.optEntradasSaidas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optEntradasSaidas.start - 1 + items) >= total) {
        this.optEntradasSaidas.end = total;
      } else {
        this.optEntradasSaidas.end = Number.parseInt(this.optEntradasSaidas.start - 1 + items);
      }

      this.entradasSaidas = res.data;
      this.optEntradasSaidas.total = total;
      this.entradasSaidasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler movimentações. Verifique a ligação");
    });
  };

  entradasSaidasSort = keyname => {
    if (this.optEntradasSaidas.order === keyname)
      this.optEntradasSaidas.page = 1;
    this.optEntradasSaidas.order = keyname;
    this.optEntradasSaidas.sort = this.optEntradasSaidas.sort === 'asc' ? 'desc' : 'asc';
    this.getEntradasSaidasForInvestigador();
  };

  entradasSaidasItem = val => {
    this.optEntradasSaidas.items = val;
    this.optEntradasSaidas.page = 1;
    this.getEntradasSaidasForInvestigador();
  };

  entradasSaidasPage = sum => {
    this.optEntradasSaidas.page += sum;
    if (this.optEntradasSaidas.page < 1)
      this.optEntradasSaidas.page = 1;
    if (this.optEntradasSaidas.page > Math.ceil(this.optEntradasSaidas.total / this.optEntradasSaidas.items))
      this.optEntradasSaidas.page = Math.ceil(this.optEntradasSaidas.total / this.optEntradasSaidas.items);
    this.getEntradasSaidasForInvestigador();
  };

  viewEntradaSaida = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./entrada.saida.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataEntrada = moment($scope.data.dataEntrada).isValid() ? moment($scope.data.dataEntrada).format('DD/MM/YYYY') : null;
        $scope.data.dataSaida = moment($scope.data.dataSaida).isValid() ? moment($scope.data.dataSaida).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Graus Académicos
  grausAcademicosModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let grauAcademico = {};
    let auxGrauSelection = undefined;
    if (edit && data != null) {
      grauAcademico = angular.copy(data);
      auxGrauSelection = grauAcademico.grauAcademico;
    }
    let wait = this.UI.showWaiting();
    this.GrauAcademico.find({
    }).$promise.then((grausAcademicos) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.grau.academico.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Grau Académico";
          scope.grauAcademico = grauAcademico;
          scope.grausAcademicos = grausAcademicos;

          scope.auxGrau = {
            selected: auxGrauSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          scope.dateOptions = {
            data: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler graus académicos. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo grau académico para investigador
  addGrauAcademico = () => {
    this.grausAcademicosModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrau && ok.grauAcademico) {
          this.grausAcademicosLoading = true;
          let item = angular.copy(ok.grauAcademico);
          item.data = item.data.format(); // Use text instead of moment
          item.grauAcademicoId = ok.auxGrau.selected.id;
          item.grauAcademico = angular.copy(ok.auxGrau.selected);

          this.InvestigatorService.createMultipleData(this.InvestigadorGrauAcademico, [item], this.id, 'investigadorId').then((ok) => {
            this.data.ok = ok.ok;
            this.UI.addToast("Grau Académico adicionado com sucesso");
            this.getGrausAcademicosForInvestigador();
          }).catch(error => {
            this.grausAcademicosLoading = false;
            this.UI.addToast("Erro ao inserir grau académico. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de grau académico para investigador
  editGrauAcademico = (x) => {
    this.grausAcademicosModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrau && ok.grauAcademico) {
          this.grausAcademicosLoading = true;
          // Update data without replacing the variable e (so it's still an element of the array)
          x.data = ok.grauAcademico.data.format(); // Use text instead of moment
          x.observacoes = ok.grauAcademico.observacoes;
          x.grauAcademicoId = ok.auxGrau.selected.id;
          x.grauAcademico = angular.copy(ok.auxGrau.selected);

          this.InvestigatorService.updateMultipleData(this.InvestigadorGrauAcademico, [x]).then((res) => {
            this.UI.addToast("Grau Académico atualizado com sucesso");
            this.getGrausAcademicosForInvestigador();
          }).catch((error) => {
            this.grausAcademicosLoading = false;
            this.UI.addToast("Erro ao atualizar grau académico. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteGrauAcademico = (x) => {
    let title = "Eliminar Grau";
    let warning = "Tem a certeza que pretende remover este grau académico?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeGrauAcademico(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeGrauAcademico = (x) => {
    this.grausAcademicosLoading = true;
    // Find again grau academico to delete, so we can update it
    this.InvestigadorGrauAcademico.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((grauAcademicoToRemove) => {
      // Only for mandatory existing multiple data
      this.InvestigadorGrauAcademico.count({
        fields: {id: true},
        where: {
          investigadorId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other graus academicos still remaining

          // Remove data
          this.InvestigadorGrauAcademico.deleteById({
            id: grauAcademicoToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Grau Académico removido com sucesso");
            this.getGrausAcademicosForInvestigador();
          });

        } else { // No other graus academicos exist, can't remove
          this.grausAcademicosLoading = false;
          this.UI.showAlert("Não foi possível apagar o grau académico porque tem que haver pelo menos 1 registo para o investigador");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar graus académicos. Verifique a ligação");
        this.getGrausAcademicosForInvestigador();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar grau académico. Verifique se ainda existe.");
      this.getGrausAcademicosForInvestigador();
    });
  };

  getGrausAcademicosForInvestigador = () => {
    this.grausAcademicosLoading = true;
    let whereLiteral = {
      'InvestigadorGrauAcademico.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optGrausAcademicos.filter).forEach(f => {
      if (this.optGrausAcademicos.filter[f])
        where[f] = this.optGrausAcademicos.filter[f];
    });
    this.InvestigadorGrauAcademico.table({
      params: {
        fields: [
          'InvestigadorGrauAcademico.id as id',
          'InvestigadorGrauAcademico.investigadorId as investigadorId',
          'InvestigadorGrauAcademico.grauAcademicoId as grauAcademicoId',
          'InvestigadorGrauAcademico.data as data',
          'InvestigadorGrauAcademico.criadoPorId as criadoPorId',
          'InvestigadorGrauAcademico.dataCriacao as dataCriacao',
          'InvestigadorGrauAcademico.atualizadoa as atualizadoa',
          'InvestigadorGrauAcademico.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'GrauAcademico.id as auxGrauId',
          'GrauAcademico.sigla as auxGrauSigla',
          'GrauAcademico.descricao as auxGrauDescricao',
        ],
        from: ['InvestigadorGrauAcademico', 'User', 'User', 'GrauAcademico'],
        references: [undefined, 'InvestigadorGrauAcademico.criadoPorId', 'InvestigadorGrauAcademico.atualizadoPorId', 'InvestigadorGrauAcademico.grauAcademicoId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optGrausAcademicos.order,
        sort: this.optGrausAcademicos.sort,
        limit: this.optGrausAcademicos.items,
        skip: (this.optGrausAcademicos.page - 1) * this.optGrausAcademicos.items,
      }
    }).$promise.then(res => {
      let page = this.optGrausAcademicos.page;
      let items = this.optGrausAcademicos.items;

      let total = res.count;

      this.optGrausAcademicos.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optGrausAcademicos.start - 1 + items) >= total) {
        this.optGrausAcademicos.end = total;
      } else {
        this.optGrausAcademicos.end = Number.parseInt(this.optGrausAcademicos.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.grauAcademico = {
          id: x.auxGrauId,
          sigla: x.auxGrauSigla,
          descricao: x.auxGrauDescricao
        };
      });

      this.grausAcademicos = res.data;
      this.optGrausAcademicos.total = total;
      this.grausAcademicosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler graus académicos. Verifique a ligação");
    });
  };

  grausAcademicosSort = keyname => {
    if (this.optGrausAcademicos.order === keyname)
      this.optGrausAcademicos.page = 1;
    this.optGrausAcademicos.order = keyname;
    this.optGrausAcademicos.sort = this.optGrausAcademicos.sort === 'asc' ? 'desc' : 'asc';
    this.getGrausAcademicosForInvestigador();
  };

  grausAcademicosItem = val => {
    this.optGrausAcademicos.items = val;
    this.optGrausAcademicos.page = 1;
    this.getGrausAcademicosForInvestigador();
  };

  grausAcademicosPage = sum => {
    this.optGrausAcademicos.page += sum;
    if (this.optGrausAcademicos.page < 1)
      this.optGrausAcademicos.page = 1;
    if (this.optGrausAcademicos.page > Math.ceil(this.optGrausAcademicos.total / this.optGrausAcademicos.items))
      this.optGrausAcademicos.page = Math.ceil(this.optGrausAcademicos.total / this.optGrausAcademicos.items);
    this.getGrausAcademicosForInvestigador();
  };

  viewGrauAcademico = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./grau.academico.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.data = moment($scope.data.data).isValid() ? moment($scope.data.data).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Citações
  citacoesModalOptions = (data, edit) => {
    let citacao = {};
    if (edit && data != null) {
      citacao = angular.copy(data);
    }
    return {
      size: 'lg',
      template: require('./../new/edit.citacao.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.citacao = citacao;
        scope.label = (edit ? "Editar" : "Nova") + " Contagem de Citações para Investigador";

        // Current year as max be able to add citacoes
        scope.year = moment().format('YYYY');
        if (!edit)
          scope.citacao.dataAtualizacao = moment();

        // Use today as default
        scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };
  };

  // Adicionar uma nova citação para investigador
  addCitacao = () => {
    let options = this.citacoesModalOptions(null, false);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.citacao) {
        this.citacoesLoading = true;
        let item = angular.copy(ok.citacao);
        item.dataAtualizacao = item.dataAtualizacao.format(); // Use text instead of moment

        this.InvestigatorService.createMultipleData(this.InvestigadorCitacao, [item], this.id, 'investigadorId').then((ok) => {
          this.data.ok = ok.ok;
          this.UI.addToast("Contagem de Citações criada com sucesso");
          this.getCitacoesForInvestigador();
        }).catch(error => {
          this.citacoesLoading = false;
          this.UI.addToast("Erro ao inserir contagem de citações. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Edita informação de citação para investigador
  editCitacao = (x) => {
    let options = this.citacoesModalOptions(x, true);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.citacao) {
        this.citacoesLoading = true;
        // Update data without replacing the variable e (so it's still an element of the array)
        x.ano = ok.citacao.ano;
        x.numCitacoesAno = ok.citacao.numCitacoesAno;
        x.numCitacoesTotal = ok.citacao.numCitacoesTotal;
        x.dataAtualizacao = ok.citacao.dataAtualizacao.format(); // Use text instead of moment

        this.InvestigatorService.updateMultipleData(this.InvestigadorCitacao, [x]).then((res) => {
          this.UI.addToast("Contagem de citações atualizada com sucesso");
          this.getCitacoesForInvestigador();
        }).catch((error) => {
          this.citacoesLoading = false;
          this.UI.addToast("Erro ao atualizar contagem de citações. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Ask confirmation to delete citação
  confirmDeleteCitacao = (x) => {
    let title = "Eliminar Contagem de Citações";
    let warning = "Tem a certeza que pretende remover esta contagem?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeCitacao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeCitacao = (x) => {
    this.citacoesLoading = true;
    // Find again citacao to delete so we can update it
    this.InvestigadorCitacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((citacaoToRemove) => {
      // Remove data
      this.InvestigadorCitacao.deleteById({
        id: citacaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Contagem de citações removida com sucesso");
        this.getCitacoesForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar contagem. Verifique se ainda existe.");
      this.getCitacoesForInvestigador();
    });
  };

  getCitacoesForInvestigador = () => {
    this.citacoesLoading = true;
    let whereLiteral = {
      'InvestigadorCitacao.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optCitacoes.filter).forEach(f => {
      if (this.optCitacoes.filter[f])
        where[f] = this.optCitacoes.filter[f];
    });
    this.InvestigadorCitacao.table({
      params: {
        fields: [
          'InvestigadorCitacao.id as id',
          'InvestigadorCitacao.investigadorId as investigadorId',
          'InvestigadorCitacao.ano as ano',
          'InvestigadorCitacao.numCitacoesAno as numCitacoesAno',
          'InvestigadorCitacao.numCitacoesTotal as numCitacoesTotal',
          'InvestigadorCitacao.dataAtualizacao as dataAtualizacao',
          'InvestigadorCitacao.criadoPorId as criadoPorId',
          'InvestigadorCitacao.dataCriacao as dataCriacao',
          'InvestigadorCitacao.atualizadoa as atualizadoa',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName'
        ],
        from: ['InvestigadorCitacao', 'User', 'User'],
        references: [undefined, 'InvestigadorCitacao.criadoPorId', 'InvestigadorCitacao.atualizadoPorId'],
        aliases: [null, null, 'User2'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optCitacoes.order,
        sort: this.optCitacoes.sort,
        limit: this.optCitacoes.items,
        skip: (this.optCitacoes.page - 1) * this.optCitacoes.items,
      }
    }).$promise.then(res => {
      let page = this.optCitacoes.page;
      let items = this.optCitacoes.items;

      let total = res.count;

      this.optCitacoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optCitacoes.start - 1 + items) >= total) {
        this.optCitacoes.end = total;
      } else {
        this.optCitacoes.end = Number.parseInt(this.optCitacoes.start - 1 + items);
      }

      this.citacoes = res.data;
      this.optCitacoes.total = total;
      this.citacoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler contagem de citações. Verifique a ligação");
    });
  };

  citacoesSort = keyname => {
    if (this.optCitacoes.order === keyname)
      this.optCitacoes.page = 1;
    this.optCitacoes.order = keyname;
    this.optCitacoes.sort = this.optCitacoes.sort === 'asc' ? 'desc' : 'asc';
    this.getCitacoesForInvestigador();
  };

  citacoesItem = val => {
    this.optCitacoes.items = val;
    this.optCitacoes.page = 1;
    this.getCitacoesForInvestigador();
  };

  citacoesPage = sum => {
    this.optCitacoes.page += sum;
    if (this.optCitacoes.page < 1)
      this.optCitacoes.page = 1;
    if (this.optCitacoes.page > Math.ceil(this.optCitacoes.total / this.optCitacoes.items))
      this.optCitacoes.page = Math.ceil(this.optCitacoes.total / this.optCitacoes.items);
    this.getCitacoesForInvestigador();
  };

  viewCitacao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./citacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataAtualizacao = moment($scope.data.dataAtualizacao).isValid() ? moment($scope.data.dataAtualizacao).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Tipos de Investigador
  tiposInvestigadorModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let tipoInvestigador = {};
    let auxTipoSelection = undefined;
    if (edit && data != null) {
      tipoInvestigador = angular.copy(data);
      auxTipoSelection = tipoInvestigador.tipoInvestigador;
    }
    let wait = this.UI.showWaiting();
    this.InvestigadorTipo.find({
    }).$promise.then((tipos) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.tipo.investigador.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Tipo de Investigador";
          scope.tipoInvestigador = tipoInvestigador;
          scope.tipos = tipos;

          scope.auxTipo = {
            selected: auxTipoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };
          scope.removeDate = this.UI.removeDate;
          scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de investigador. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo tipo para investigador
  addTipoInvestigador = () => {
    this.tiposInvestigadorModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.tipoInvestigador) {
          this.tiposInvestigadorLoading = true;
          let item = angular.copy(ok.tipoInvestigador);
          item.dataInicio = item.dataInicio.format(); // Use text instead of moment
          if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
            item.dataFim = item.dataFim.format(); // Use text instead of moment
          else
            item.dataFim = null;
          item.tipoId = ok.auxTipo.selected.id;
          item.tipoInvestigador = angular.copy(ok.auxTipo.selected);

          this.InvestigatorService.createMultipleData(this.InvestigadorTipoInvestigador, [item], this.id, 'investigadorId').then((ok) => {
            this.data.ok = ok.ok;
            this.UI.addToast("Tipo de Investigador adicionado com sucesso");
            this.getTiposInvestigadorForInvestigador();
          }).catch(error => {
            this.tiposInvestigadorLoading = false;
            this.UI.addToast("Erro ao inserir tipo de investigador. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de tipo para investigador
  editTipoInvestigador = (x) => {
    this.tiposInvestigadorModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.tipoInvestigador) {
          this.tiposInvestigadorLoading = true;
          // Update data without replacing the variable e (so it's still an element of the array)
          x.dataInicio = ok.tipoInvestigador.dataInicio.format(); // Use text instead of moment
          if (ok.tipoInvestigador.dataFim != null && ok.tipoInvestigador.dataFim.isValid()) // null, undefined or invalid date
            x.dataFim = ok.tipoInvestigador.dataFim.format(); // Use text instead of moment
          else
            x.dataFim = null;
          x.observacoes = ok.tipoInvestigador.observacoes;
          x.tipoId = ok.auxTipo.selected.id;
          x.tipoInvestigador = angular.copy(ok.auxTipo.selected);

          this.InvestigatorService.updateMultipleData(this.InvestigadorTipoInvestigador, [x]).then((res) => {
            this.UI.addToast("Tipo de Investigador atualizado com sucesso");
            this.getTiposInvestigadorForInvestigador();
          }).catch((error) => {
            this.tiposInvestigadorLoading = false;
            this.UI.addToast("Erro ao atualizar tipo de investigador. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete tipo
  confirmDeleteTipoInvestigador = (x) => {
    let title = "Eliminar Tipo de Investigador";
    let warning = "Tem a certeza que pretende remover este tipo de investigador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeTipoInvestigador(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeTipoInvestigador = (x) => {
    this.tiposInvestigadorLoading = true;
    // Find again grau academico to delete, so we can update it
    this.InvestigadorTipoInvestigador.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((tipoInvestigadorToRemove) => {
      // Only for mandatory existing multiple data
      this.InvestigadorTipoInvestigador.count({
        fields: {id: true},
        where: {
          investigadorId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other tipos de investigador still remaining

          // Remove data
          this.InvestigadorTipoInvestigador.deleteById({
            id: tipoInvestigadorToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Tipo de Investigador removido com sucesso");
            this.getTiposInvestigadorForInvestigador();
          });

        } else { // No other tipos exist, can't remove
          this.tiposInvestigadorLoading = false;
          this.UI.showAlert("Não foi possível apagar o tipo de investigador porque tem que haver pelo menos 1 registo para o investigador");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar tipos de investigador. Verifique a ligação");
        this.getTiposInvestigadorForInvestigador();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar tipo de investigador. Verifique se ainda existe.");
      this.getTiposInvestigadorForInvestigador();
    });
  };

  getTiposInvestigadorForInvestigador = () => {
    this.tiposInvestigadorLoading = true;
    let whereLiteral = {
      'InvestigadorTipoInvestigador.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optTiposInvestigador.filter).forEach(f => {
      if (this.optTiposInvestigador.filter[f])
        where[f] = this.optTiposInvestigador.filter[f];
    });
    this.InvestigadorTipoInvestigador.table({
      params: {
        fields: [
          'InvestigadorTipoInvestigador.id as id',
          'InvestigadorTipoInvestigador.investigadorId as investigadorId',
          'InvestigadorTipoInvestigador.tipoId as tipoId',
          'InvestigadorTipoInvestigador.dataInicio as dataInicio',
          'InvestigadorTipoInvestigador.dataFim as dataFim',
          'InvestigadorTipoInvestigador.criadoPorId as criadoPorId',
          'InvestigadorTipoInvestigador.dataCriacao as dataCriacao',
          'InvestigadorTipoInvestigador.atualizadoa as atualizadoa',
          'InvestigadorTipoInvestigador.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'InvestigadorTipo.id as auxTipoId',
          'InvestigadorTipo.designacao as auxTipoDesignacao',
        ],
        from: ['InvestigadorTipoInvestigador', 'User', 'User', 'InvestigadorTipo'],
        references: [undefined, 'InvestigadorTipoInvestigador.criadoPorId', 'InvestigadorTipoInvestigador.atualizadoPorId', 'InvestigadorTipoInvestigador.tipoId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optTiposInvestigador.order,
        sort: this.optTiposInvestigador.sort,
        limit: this.optTiposInvestigador.items,
        skip: (this.optTiposInvestigador.page - 1) * this.optTiposInvestigador.items,
      }
    }).$promise.then(res => {
      let page = this.optTiposInvestigador.page;
      let items = this.optTiposInvestigador.items;

      let total = res.count;

      this.optTiposInvestigador.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optTiposInvestigador.start - 1 + items) >= total) {
        this.optTiposInvestigador.end = total;
      } else {
        this.optTiposInvestigador.end = Number.parseInt(this.optTiposInvestigador.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.tipoInvestigador = {
          id: x.auxTipoId,
          designacao: x.auxTipoDesignacao
        };
      });

      this.tiposInvestigador = res.data;
      this.optTiposInvestigador.total = total;
      this.tiposInvestigadorLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler tipos de investigador. Verifique a ligação");
    });
  };

  tiposInvestigadorSort = keyname => {
    if (this.optTiposInvestigador.order === keyname)
      this.optTiposInvestigador.page = 1;
    this.optTiposInvestigador.order = keyname;
    this.optTiposInvestigador.sort = this.optTiposInvestigador.sort === 'asc' ? 'desc' : 'asc';
    this.getTiposInvestigadorForInvestigador();
  };

  tiposInvestigadorItem = val => {
    this.optTiposInvestigador.items = val;
    this.optTiposInvestigador.page = 1;
    this.getTiposInvestigadorForInvestigador();
  };

  tiposInvestigadorPage = sum => {
    this.optTiposInvestigador.page += sum;
    if (this.optTiposInvestigador.page < 1)
      this.optTiposInvestigador.page = 1;
    if (this.optTiposInvestigador.page > Math.ceil(this.optTiposInvestigador.total / this.optTiposInvestigador.items))
      this.optTiposInvestigador.page = Math.ceil(this.optTiposInvestigador.total / this.optTiposInvestigador.items);
    this.getTiposInvestigadorForInvestigador();
  };

  viewTipoInvestigador = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./tipo.investigador.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataInicio = moment($scope.data.dataInicio).isValid() ? moment($scope.data.dataInicio).format('DD/MM/YYYY') : null;
        $scope.data.dataFim = moment($scope.data.dataFim).isValid() ? moment($scope.data.dataFim).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // H-Values
  hValuesModalOptions = (data, edit) => {
    let hValue = {};
    if (edit && data != null) {
      hValue = angular.copy(data);
    }
    return {
      size: 'lg',
      template: require('./../new/edit.hvalue.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.hValue = hValue;
        scope.label = (edit ? "Editar" : "Novo") + " H-value para Investigador";

        // Current year as max be able to add h-value
        scope.year = moment().format('YYYY');
        if (!edit)
          scope.hValue.dataAtualizacao = moment();

        // Use today as default
        scope.dateOptions = {
          dataAtualizacao: {
            format: 'DD/MM/YYYY',
            maxDate: moment()
          }
        };

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };
  };

  // Adicionar um novo h-value para investigador
  addHValue = () => {
    let options = this.hValuesModalOptions(null, false);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.hValue) {
        this.hValuesLoading = true;
        let item = angular.copy(ok.hValue);
        item.dataAtualizacao = item.dataAtualizacao.format(); // Use text instead of moment

        this.InvestigatorService.createMultipleData(this.InvestigadorHValue, [item], this.id, 'investigadorId').then((ok) => {
          this.data.ok = ok.ok;
          this.UI.addToast("H-value criado com sucesso");
          this.getHValuesForInvestigador();
        }).catch(error => {
          this.hValuesLoading = false;
          this.UI.addToast("Erro ao inserir h-value. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Edita informação de h-value para investigador
  editHValue = (x) => {
    let options = this.hValuesModalOptions(x, true);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.hValue) {
        this.hValuesLoading = true;
        // Update data without replacing the variable e (so it's still an element of the array)
        x.ano = ok.hValue.ano;
        x.hValue = ok.hValue.hValue;
        x.dataAtualizacao = ok.hValue.dataAtualizacao.format(); // Use text instead of moment
        x.observacoes = ok.hValue.observacoes;

        this.InvestigatorService.updateMultipleData(this.InvestigadorHValue, [x]).then((res) => {
          this.UI.addToast("H-value atualizado com sucesso");
          this.getHValuesForInvestigador();
        }).catch((error) => {
          this.hValuesLoading = false;
          this.UI.addToast("Erro ao atualizar h-value. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Ask confirmation to delete h-value
  confirmDeleteHValue = (x) => {
    let title = "Eliminar H-value";
    let warning = "Tem a certeza que pretende remover este h-value?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeHValue(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeHValue = (x) => {
    this.hValuesLoading = true;
    // Find again h-value to delete so we can update it
    this.InvestigadorHValue.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((hValueToRemove) => {
      // Remove data
      this.InvestigadorHValue.deleteById({
        id: hValueToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("H-value removido com sucesso");
        this.getHValuesForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar h-value. Verifique se ainda existe.");
      this.getHValuesForInvestigador();
    });
  };

  getHValuesForInvestigador = () => {
    this.hValuesLoading = true;
    let whereLiteral = {
      'InvestigadorHValue.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optHValues.filter).forEach(f => {
      if (this.optHValues.filter[f])
        where[f] = this.optHValues.filter[f];
    });
    this.InvestigadorHValue.table({
      params: {
        fields: [
          'InvestigadorHValue.id as id',
          'InvestigadorHValue.investigadorId as investigadorId',
          'InvestigadorHValue.ano as ano',
          'InvestigadorHValue.hValue as hValue',
          'InvestigadorHValue.dataAtualizacao as dataAtualizacao',
          'InvestigadorHValue.criadoPorId as criadoPorId',
          'InvestigadorHValue.dataCriacao as dataCriacao',
          'InvestigadorHValue.atualizadoa as atualizadoa',
          'InvestigadorHValue.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName'
        ],
        from: ['InvestigadorHValue', 'User', 'User'],
        references: [undefined, 'InvestigadorHValue.criadoPorId', 'InvestigadorHValue.atualizadoPorId'],
        aliases: [null, null, 'User2'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optHValues.order,
        sort: this.optHValues.sort,
        limit: this.optHValues.items,
        skip: (this.optHValues.page - 1) * this.optHValues.items,
      }
    }).$promise.then(res => {
      let page = this.optHValues.page;
      let items = this.optHValues.items;

      let total = res.count;

      this.optHValues.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optHValues.start - 1 + items) >= total) {
        this.optHValues.end = total;
      } else {
        this.optHValues.end = Number.parseInt(this.optHValues.start - 1 + items);
      }

      this.hValues = res.data;
      this.optHValues.total = total;
      this.hValuesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler h-values. Verifique a ligação");
    });
  };

  hValuesSort = keyname => {
    if (this.optHValues.order === keyname)
      this.optHValues.page = 1;
    this.optHValues.order = keyname;
    this.optHValues.sort = this.optHValues.sort === 'asc' ? 'desc' : 'asc';
    this.getHValuesForInvestigador();
  };

  hValuesItem = val => {
    this.optHValues.items = val;
    this.optHValues.page = 1;
    this.getHValuesForInvestigador();
  };

  hValuesPage = sum => {
    this.optHValues.page += sum;
    if (this.optHValues.page < 1)
      this.optHValues.page = 1;
    if (this.optHValues.page > Math.ceil(this.optHValues.total / this.optHValues.items))
      this.optHValues.page = Math.ceil(this.optHValues.total / this.optHValues.items);
    this.getHValuesForInvestigador();
  };

  viewHValue = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./hvalue.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataAtualizacao = moment($scope.data.dataAtualizacao).isValid() ? moment($scope.data.dataAtualizacao).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Contratação
  contratacoesModalOptions = (data, edit) => {
    let contratacao = {};
    if (edit && data != null) {
      contratacao = angular.copy(data);
    }
    return {
      size: 'lg',
      template: require('./../new/edit.contratacao.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.label = (edit ? "Editar" : "Nova") + " Contratação";
        scope.contratacao = contratacao;
        scope.removeDate = this.UI.removeDate;
        scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };
  };

  // Adicionar uma nova contratação para investigador
  addContratacao = () => {
    let options = this.contratacoesModalOptions(null, false);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.contratacao) {
        this.contratacoesLoading = true;
        let item = angular.copy(ok.contratacao);
        item.dataInicio = item.dataInicio.format(); // Use text instead of moment
        if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
          item.dataFim = item.dataFim.format(); // Use text instead of moment
        else
          item.dataFim = null;

        this.InvestigatorService.createMultipleData(this.InvestigadorContratacao, [item], this.id, 'investigadorId').then((ok) => {
          this.data.ok = ok.ok;
          this.UI.addToast("Contratação criada com sucesso");
          this.getContratacoesForInvestigador();
        }).catch(error => {
          this.contratacoesLoading = false;
          this.UI.addToast("Erro ao inserir contratação. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Edita informação de contratação para investigador
  editContratacao = (x) => {
    let options = this.contratacoesModalOptions(x, true);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.contratacao) {
        this.contratacoesLoading = true;
        // Update data without replacing the variable e (so it's still an element of the array)
        x.dataInicio = ok.contratacao.dataInicio.format(); // Use text instead of moment
        if (ok.contratacao.dataFim != null && ok.contratacao.dataFim.isValid())
          x.dataFim = ok.contratacao.dataFim.format(); // Use text instead of moment
        else
          x.dataFim = null;
        x.observacoes = ok.contratacao.observacoes;

        this.InvestigatorService.updateMultipleData(this.InvestigadorContratacao, [x]).then((res) => {
          this.UI.addToast("Contratação atualizada com sucesso");
          this.getContratacoesForInvestigador();
        }).catch((error) => {
          this.contratacoesLoading = false;
          this.UI.addToast("Erro ao atualizar contratação. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Ask confirmation to delete contratação
  confirmDeleteContratacao = (x) => {
    let title = "Eliminar Contratação";
    let warning = "Tem a certeza que pretende remover esta contratação?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeContratacao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeContratacao = (x) => {
    this.contratacoesLoading = true;
    // Find again contratação to delete so we can update it
    this.InvestigadorContratacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((contratacaoToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.InvestigadorContratacao.deleteById({
        id: contratacaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Contratação removida com sucesso");
        this.getContratacoesForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar contratação. Verifique se ainda existe.");
      this.getContratacoesForInvestigador();
    });
  };

  getContratacoesForInvestigador = () => {
    this.contratacoesLoading = true;
    let whereLiteral = {
      'InvestigadorContratacao.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optContratacoes.filter).forEach(f => {
      if (this.optContratacoes.filter[f])
        where[f] = this.optContratacoes.filter[f];
    });
    this.InvestigadorContratacao.table({
      params: {
        fields: [
          'InvestigadorContratacao.id as id',
          'InvestigadorContratacao.investigadorId as investigadorId',
          'InvestigadorContratacao.dataInicio as dataInicio',
          'InvestigadorContratacao.dataFim as dataFim',
          'InvestigadorContratacao.criadoPorId as criadoPorId',
          'InvestigadorContratacao.dataCriacao as dataCriacao',
          'InvestigadorContratacao.atualizadoa as atualizadoa',
          'InvestigadorContratacao.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName'
        ],
        from: ['InvestigadorContratacao', 'User', 'User'],
        references: [undefined, 'InvestigadorContratacao.criadoPorId', 'InvestigadorContratacao.atualizadoPorId'],
        aliases: [null, null, 'User2'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optContratacoes.order,
        sort: this.optContratacoes.sort,
        limit: this.optContratacoes.items,
        skip: (this.optContratacoes.page - 1) * this.optContratacoes.items,
      }
    }).$promise.then(res => {
      let page = this.optContratacoes.page;
      let items = this.optContratacoes.items;

      let total = res.count;

      this.optContratacoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optContratacoes.start - 1 + items) >= total) {
        this.optContratacoes.end = total;
      } else {
        this.optContratacoes.end = Number.parseInt(this.optContratacoes.start - 1 + items);
      }

      this.contratacoes = res.data;
      this.optContratacoes.total = total;
      this.contratacoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler contratações. Verifique a ligação");
    });
  };

  contratacoesSort = keyname => {
    if (this.optContratacoes.order === keyname)
      this.optContratacoes.page = 1;
    this.optContratacoes.order = keyname;
    this.optContratacoes.sort = this.optContratacoes.sort === 'asc' ? 'desc' : 'asc';
    this.getContratacoesForInvestigador();
  };

  contratacoesItem = val => {
    this.optContratacoes.items = val;
    this.optContratacoes.page = 1;
    this.getContratacoesForInvestigador();
  };

  contratacoesPage = sum => {
    this.optContratacoes.page += sum;
    if (this.optContratacoes.page < 1)
      this.optContratacoes.page = 1;
    if (this.optContratacoes.page > Math.ceil(this.optContratacoes.total / this.optContratacoes.items))
      this.optContratacoes.page = Math.ceil(this.optContratacoes.total / this.optContratacoes.items);
    this.getContratacoesForInvestigador();
  };

  viewContratacao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./contratacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataInicio = moment($scope.data.dataInicio).isValid() ? moment($scope.data.dataInicio).format('DD/MM/YYYY') : null;
        $scope.data.dataFim = moment($scope.data.dataFim).isValid() ? moment($scope.data.dataFim).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Atividades
  atividadesModalOptions = (data, edit) => {
    let atividade = {};
    if (edit && data != null) {
      atividade = angular.copy(data);
    }
    return {
      size: 'lg',
      template: require('./../new/edit.atividade.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.label = (edit ? "Editar" : "Nova") + " Atividade";
        scope.atividade = atividade;
        scope.removeDate = this.UI.removeDate;
        scope.dateOptions = {
          dataInicio: {format: 'DD/MM/YYYY'},
          dataFim: {format: 'DD/MM/YYYY'}
        };

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };
  };

  // Adicionar uma nova atividade para investigador
  addAtividade = () => {
    let options = this.atividadesModalOptions(null, false);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.atividade) {
        this.atividadesLoading = true;
        let item = angular.copy(ok.atividade);
        item.dataInicio = item.dataInicio.format(); // Use text instead of moment
        if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
          item.dataFim = item.dataFim.format(); // Use text instead of moment
        else
          item.dataFim = null;

        this.InvestigatorService.createMultipleData(this.InvestigadorAtividade, [item], this.id, 'investigadorId').then((ok) => {
          this.data.ok = ok.ok;
          this.UI.addToast("Atividade criada com sucesso");
          this.getAtividadesForInvestigador();
        }).catch(error => {
          this.atividadesLoading = false;
          this.UI.addToast("Erro ao inserir atividade. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Edita informação de atividade para investigador
  editAtividade = (x) => {
    let options = this.atividadesModalOptions(x, true);
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.atividade) {
        this.atividadesLoading = true;
        // Update data without replacing the variable e (so it's still an element of the array)
        x.dataInicio = ok.atividade.dataInicio.format(); // Use text instead of moment
        if (ok.atividade.dataFim != null && ok.atividade.dataFim.isValid())
          x.dataFim = ok.atividade.dataFim.format(); // Use text instead of moment
        else
          x.dataFim = null;
        x.observacoes = ok.atividade.observacoes;

        this.InvestigatorService.updateMultipleData(this.InvestigadorAtividade, [x]).then((res) => {
          this.UI.addToast("Atividade atualizada com sucesso");
          this.getAtividadesForInvestigador();
        }).catch((error) => {
          this.atividadesLoading = false;
          this.UI.addToast("Erro ao atualizar atividade. Verifique a ligação");
          console.log(error);
        });
      }
    });
  };

  // Ask confirmation to delete atividade
  confirmDeleteAtividade = (x) => {
    let title = "Eliminar Atividade";
    let warning = "Tem a certeza que pretende remover esta atividade?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeAtividade(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeAtividade = (x) => {
    this.atividadesLoading = true;
    // Find again contratação to delete so we can update it
    this.InvestigadorAtividade.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((atividadeToRemove) => {
      // Only for mandatory existing multiple data
      this.InvestigadorAtividade.count({
        fields: {id: true},
        where: {
          investigadorId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other atividades still remaining

          // Remove data
          this.InvestigadorAtividade.deleteById({
            id: atividadeToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Atividade removida com sucesso");
            this.getAtividadesForInvestigador();
          });

        } else { // No other atividade exist, can't remove
          this.atividadesLoading = false;
          this.UI.showAlert("Não foi possível apagar o registo de atividade porque tem que haver pelo menos 1 registo para o investigador");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar atividades. Verifique a ligação");
        this.getAtividadesForInvestigador();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar atividade. Verifique se ainda existe.");
      this.getAtividadesForInvestigador();
    });
  };

  getAtividadesForInvestigador = () => {
    this.atividadesLoading = true;
    let whereLiteral = {
      'InvestigadorAtividade.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optAtividades.filter).forEach(f => {
      if (this.optAtividades.filter[f])
        where[f] = this.optAtividades.filter[f];
    });
    this.InvestigadorAtividade.table({
      params: {
        fields: [
          'InvestigadorAtividade.id as id',
          'InvestigadorAtividade.investigadorId as investigadorId',
          'InvestigadorAtividade.dataInicio as dataInicio',
          'InvestigadorAtividade.dataFim as dataFim',
          'InvestigadorAtividade.criadoPorId as criadoPorId',
          'InvestigadorAtividade.dataCriacao as dataCriacao',
          'InvestigadorAtividade.atualizadoa as atualizadoa',
          'InvestigadorAtividade.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName'
        ],
        from: ['InvestigadorAtividade', 'User', 'User'],
        references: [undefined, 'InvestigadorAtividade.criadoPorId', 'InvestigadorAtividade.atualizadoPorId'],
        aliases: [null, null, 'User2'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optAtividades.order,
        sort: this.optAtividades.sort,
        limit: this.optAtividades.items,
        skip: (this.optAtividades.page - 1) * this.optAtividades.items,
      }
    }).$promise.then(res => {
      let page = this.optAtividades.page;
      let items = this.optAtividades.items;

      let total = res.count;

      this.optAtividades.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAtividades.start - 1 + items) >= total) {
        this.optAtividades.end = total;
      } else {
        this.optAtividades.end = Number.parseInt(this.optAtividades.start - 1 + items);
      }

      this.atividades = res.data;
      this.optAtividades.total = total;
      this.atividadesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler atividades. Verifique a ligação");
    });
  };

  atividadesSort = keyname => {
    if (this.optAtividades.order === keyname)
      this.optAtividades.page = 1;
    this.optAtividades.order = keyname;
    this.optAtividades.sort = this.optAtividades.sort === 'asc' ? 'desc' : 'asc';
    this.getAtividadesForInvestigador();
  };

  atividadesItem = val => {
    this.optAtividades.items = val;
    this.optAtividades.page = 1;
    this.getAtividadesForInvestigador();
  };

  atividadesPage = sum => {
    this.optAtividades.page += sum;
    if (this.optAtividades.page < 1)
      this.optAtividades.page = 1;
    if (this.optAtividades.page > Math.ceil(this.optAtividades.total / this.optAtividades.items))
      this.optAtividades.page = Math.ceil(this.optAtividades.total / this.optAtividades.items);
    this.getAtividadesForInvestigador();
  };

  viewAtividade = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./atividade.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataInicio = moment($scope.data.dataInicio).isValid() ? moment($scope.data.dataInicio).format('DD/MM/YYYY') : null;
        $scope.data.dataFim = moment($scope.data.dataFim).isValid() ? moment($scope.data.dataFim).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Participação em Gestão
  participacaoGestaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let participacao = {};
    let auxTipoSelection = undefined;
    if (edit && data != null) {
      participacao = angular.copy(data);
      auxTipoSelection = participacao.tipoParticipacao;
    }
    let wait = this.UI.showWaiting();
    this.TipoParticipacaoGestao.find({
    }).$promise.then((tipos) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.participacao.gestao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Participação em Gestão";
          scope.participacao = participacao;
          scope.tipos = tipos;

          scope.auxTipo = {
            selected: auxTipoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };
          scope.removeDate = this.UI.removeDate;
          scope.dateOptions = {
            dataInicio: {format: 'DD/MM/YYYY'},
            dataFim: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler tipos de participação. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar uma nova participação em gestão para investigador
  addParticipacaoGestao = () => {
    this.participacaoGestaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.participacao) {
          this.participacaoGestaoLoading = true;
          let item = angular.copy(ok.participacao);
          item.dataInicio = item.dataInicio.format(); // Use text instead of moment
          if (item.dataFim != null && item.dataFim.isValid()) // null, undefined or invalid date
            item.dataFim = item.dataFim.format(); // Use text instead of moment
          else
            item.dataFim = null;
          item.tipoId = ok.auxTipo.selected.id;
          item.tipoParticipacao = angular.copy(ok.auxTipo.selected);

          this.InvestigatorService.createMultipleData(this.InvestigadorParticipacaoGestao, [item], this.id, 'investigadorId').then((ok) => {
            this.data.ok = ok.ok;
            this.UI.addToast("Participação em Gestão adicionada com sucesso");
            this.getParticipacaoGestaoForInvestigador();
          }).catch(error => {
            this.participacaoGestaoLoading = false;
            this.UI.addToast("Erro ao inserir participação em gestão. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de participação em gestão para investigador
  editParticipacaoGestao = (x) => {
    this.participacaoGestaoModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxTipo && ok.participacao) {
          this.participacaoGestaoLoading = true;
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataInicio = ok.participacao.dataInicio.format(); // Use text instead of moment
          if (ok.participacao.dataFim != null && ok.participacao.dataFim.isValid()) // null, undefined or invalid date
            x.dataFim = ok.participacao.dataFim.format(); // Use text instead of moment
          else
            x.dataFim = null;
          x.observacoes = ok.participacao.observacoes;
          x.tipoId = ok.auxTipo.selected.id;
          x.tipoParticipacao = angular.copy(ok.auxTipo.selected);

          this.InvestigatorService.updateMultipleData(this.InvestigadorParticipacaoGestao, [x]).then((res) => {
            this.UI.addToast("Participação em Gestão atualizada com sucesso");
            this.getParticipacaoGestaoForInvestigador();
          }).catch((error) => {
            this.participacaoGestaoLoading = false;
            this.UI.addToast("Erro ao atualizar participação em gestão. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete participação em gestão
  confirmDeleteParticipacaoGestao = (x) => {
    let title = "Eliminar Participação em Gestão";
    let warning = "Tem a certeza que pretende remover esta participação em gestão?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeParticipacaoGestao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeParticipacaoGestao = (x) => {
    this.participacaoGestaoLoading = true;
    // Find again participacao gestao to delete, so we can update it
    this.InvestigadorParticipacaoGestao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((participacaoGestaoToRemove) => {

      // Remove data
      this.InvestigadorParticipacaoGestao.deleteById({
        id: participacaoGestaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Participação em gestão removida com sucesso");
        this.getParticipacaoGestaoForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar participação em gestão. Verifique se ainda existe.");
      this.getParticipacaoGestaoForInvestigador();
    });
  };

  getParticipacaoGestaoForInvestigador = () => {
    this.participacaoGestaoLoading = true;
    let whereLiteral = {
      'InvestigadorParticipacaoGestao.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optParticipacaoGestao.filter).forEach(f => {
      if (this.optParticipacaoGestao.filter[f])
        where[f] = this.optParticipacaoGestao.filter[f];
    });
    this.InvestigadorParticipacaoGestao.table({
      params: {
        fields: [
          'InvestigadorParticipacaoGestao.id as id',
          'InvestigadorParticipacaoGestao.investigadorId as investigadorId',
          'InvestigadorParticipacaoGestao.tipoId as tipoId',
          'InvestigadorParticipacaoGestao.dataInicio as dataInicio',
          'InvestigadorParticipacaoGestao.dataFim as dataFim',
          'InvestigadorParticipacaoGestao.criadoPorId as criadoPorId',
          'InvestigadorParticipacaoGestao.dataCriacao as dataCriacao',
          'InvestigadorParticipacaoGestao.atualizadoa as atualizadoa',
          'InvestigadorParticipacaoGestao.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'TipoParticipacaoGestao.id as auxTipoId',
          'TipoParticipacaoGestao.sigla as auxTipoSigla',
          'TipoParticipacaoGestao.descricao as auxTipoDescricao',
        ],
        from: ['InvestigadorParticipacaoGestao', 'User', 'User', 'TipoParticipacaoGestao'],
        references: [undefined, 'InvestigadorParticipacaoGestao.criadoPorId', 'InvestigadorParticipacaoGestao.atualizadoPorId', 'InvestigadorParticipacaoGestao.tipoId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optParticipacaoGestao.order,
        sort: this.optParticipacaoGestao.sort,
        limit: this.optParticipacaoGestao.items,
        skip: (this.optParticipacaoGestao.page - 1) * this.optParticipacaoGestao.items,
      }
    }).$promise.then(res => {
      let page = this.optParticipacaoGestao.page;
      let items = this.optParticipacaoGestao.items;

      let total = res.count;

      this.optParticipacaoGestao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optParticipacaoGestao.start - 1 + items) >= total) {
        this.optParticipacaoGestao.end = total;
      } else {
        this.optParticipacaoGestao.end = Number.parseInt(this.optParticipacaoGestao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.tipoParticipacao = {
          id: x.auxTipoId,
          sigla: x.auxTipoSigla,
          descricao: x.auxTipoDescricao
        };
      });

      this.participacaoGestao = res.data;
      this.optParticipacaoGestao.total = total;
      this.participacaoGestaoLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler tipos de participação. Verifique a ligação");
    });
  };

  participacaoGestaoSort = keyname => {
    if (this.optParticipacaoGestao.order === keyname)
      this.optParticipacaoGestao.page = 1;
    this.optParticipacaoGestao.order = keyname;
    this.optParticipacaoGestao.sort = this.optParticipacaoGestao.sort === 'asc' ? 'desc' : 'asc';
    this.getParticipacaoGestaoForInvestigador();
  };

  participacaoGestaoItem = val => {
    this.optParticipacaoGestao.items = val;
    this.optParticipacaoGestao.page = 1;
    this.getParticipacaoGestaoForInvestigador();
  };

  participacaoGestaoPage = sum => {
    this.optParticipacaoGestao.page += sum;
    if (this.optParticipacaoGestao.page < 1)
      this.optParticipacaoGestao.page = 1;
    if (this.optParticipacaoGestao.page > Math.ceil(this.optParticipacaoGestao.total / this.optParticipacaoGestao.items))
      this.optParticipacaoGestao.page = Math.ceil(this.optParticipacaoGestao.total / this.optParticipacaoGestao.items);
    this.getParticipacaoGestaoForInvestigador();
  };

  viewParticipacaoGestao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./participacao.gestao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataInicio = moment($scope.data.dataInicio).isValid() ? moment($scope.data.dataInicio).format('DD/MM/YYYY') : null;
        $scope.data.dataFim = moment($scope.data.dataFim).isValid() ? moment($scope.data.dataFim).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Instituições
  instituicaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let instituicao = {};
    let auxInstituicaoSelection = undefined;
    let auxCategoriaSelection = undefined;
    if (edit && data != null) {
      instituicao = angular.copy(data);
      auxInstituicaoSelection = instituicao.instituicao;
      auxCategoriaSelection = instituicao.categoria;
    }
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      this.Categoria.find({}).$promise.then((categorias) => {
        wait.close();
        defer.resolve({
          size: 'lg',
          template: require('./../new/edit.instituicao.dialog.html'),
          controller: ['$dialog', '$scope', (dialog, scope) => {
            scope.label = (edit ? "Editar" : "Nova") + " Instituição para investigador";
            scope.instituicao = instituicao;
            scope.instituicoes = instituicoes;
            scope.categorias = categorias;

            scope.auxInstituicao = {
              selected: auxInstituicaoSelection,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            scope.auxCategoria = {
              selected: auxCategoriaSelection,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            scope.removeDate = this.UI.removeDate;
            scope.dateOptions = {
              dataEntrada: {format: 'DD/MM/YYYY'},
              dataSaida: {format: 'DD/MM/YYYY'}
            };

            // Infinite Scroll magic
            scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            scope.ok = () => {
              dialog.close(scope);
            };

            scope.cancel = () => {
              dialog.dismiss('cancel');
            };
          }]
        });
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível ler categorias. Verifique a sua ligação");
        defer.reject();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova instituicao para investigador
  addInstituicao = () => {
    this.instituicaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.auxCategoria && ok.instituicao) {
          this.instituicoesLoading = true;
          let item = angular.copy(ok.instituicao);
          item.instituicaoId = ok.auxInstituicao.selected.id;
          item.instituicao = angular.copy(ok.auxInstituicao.selected);
          item.categoriaId = ok.auxCategoria.selected.id;
          item.categoria = angular.copy(ok.auxCategoria.selected);
          // Check if instituicao is already there before creating
          this.InvestigatorService.usedPartialDataForModel({investigadorId: this.id, instituicaoId: item.instituicaoId, categoriaId: item.categoriaId, dataEntrada: item.dataEntrada }, this.InvestigadorInstituicao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Combinação de Instituição, Categoria e Data de Entrada já existe");
              this.instituicoesLoading = false;
            } else { // Create it
              this.InvestigatorService.createMultipleData(this.InvestigadorInstituicao, [item], this.id, 'investigadorId').then((x) => {
                this.UI.addToast("Instituição adicionada com sucesso");
                this.getInstituicoesForInvestigador();
              }).catch(error => {
                this.instituicoesLoading = false;
                this.UI.addToast("Erro ao inserir instituição. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.instituicoesLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de instituição para investigador
  editInstituicao = (x) => {
    this.instituicaoModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.auxCategoria && ok.instituicao) {
          this.instituicoesLoading = true;
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataEntrada = ok.instituicao.dataEntrada.format(); // Use text instead of moment
          if (ok.instituicao.dataSaida != null && ok.instituicao.dataSaida.isValid()) // null, undefined or invalid date
            x.dataSaida = ok.instituicao.dataSaida.format(); // Use text instead of moment
          else
            x.dataSaida = null;
          x.observacoes = ok.instituicao.observacoes;
          x.instituicaoId = ok.auxInstituicao.selected.id;
          x.instituicao = angular.copy(ok.auxInstituicao.selected);
          x.categoriaId = ok.auxCategoria.selected.id;
          x.categoria = angular.copy(ok.auxCategoria.selected);

          this.InvestigatorService.updateMultipleData(this.InvestigadorInstituicao, [x]).then((res) => {
            this.UI.addToast("Instituição atualizada com sucesso");
            this.getInstituicoesForInvestigador();
          }).catch((error) => {
            this.instituicoesLoading = false;
            this.UI.addToast("Erro ao atualizar instituição. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete instituicao
  confirmDeleteInstituicao = (x) => {
    let title = "Eliminar Instituição";
    let warning = "Tem a certeza que pretende remover esta instituição para o investigador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeInstituicao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeInstituicao = (x) => {
    this.instituicoesLoading = true;
    // Find again instituicao to delete so we can update it
    this.InvestigadorInstituicao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((instituicaoToRemove) => {

      // Remove data
      this.InvestigadorInstituicao.deleteById({
        id: instituicaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Instituição removida com sucesso");
        this.getInstituicoesForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar instituição. Verifique se ainda existe.");
      this.getInstituicoesForInvestigador();
    });
  };

  getInstituicoesForInvestigador = () => {
    this.instituicoesLoading = true;
    let whereLiteral = {
      'InvestigadorInstituicao.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optInstituicoes.filter).forEach(f => {
      if (this.optInstituicoes.filter[f])
        where[f] = this.optInstituicoes.filter[f];
    });
    this.InvestigadorInstituicao.table({
      params: {
        fields: [
          'InvestigadorInstituicao.id as id',
          'InvestigadorInstituicao.investigadorId as investigadorId',
          'InvestigadorInstituicao.instituicaoId as instituicaoId',
          'InvestigadorInstituicao.categoriaId as categoriaId',
          'InvestigadorInstituicao.dataEntrada as dataEntrada',
          'InvestigadorInstituicao.dataSaida as dataSaida',
          'InvestigadorInstituicao.criadoPorId as criadoPorId',
          'InvestigadorInstituicao.dataCriacao as dataCriacao',
          'InvestigadorInstituicao.atualizadoa as atualizadoa',
          'InvestigadorInstituicao.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Instituicao.id as auxInstituicaoId',
          'Instituicao.designacao as auxInstituicaoDesignacao',
          'Pais.nome as auxPaisNome',
          'Categoria.id as auxCategoriaId',
          'Categoria.designacao as auxCategoriaDesignacao'
        ],
        from: ['InvestigadorInstituicao', 'User', 'User', 'Instituicao', 'Pais', 'Categoria'],
        referencesOrigin: [undefined, undefined, undefined, undefined, 'Pais.id', undefined],
        references: [undefined, 'InvestigadorInstituicao.criadoPorId', 'InvestigadorInstituicao.atualizadoPorId', 'InvestigadorInstituicao.instituicaoId', 'Instituicao.paisId', 'InvestigadorInstituicao.categoriaId'],
        aliases: [null, null, 'User2', null, null, null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optInstituicoes.order,
        sort: this.optInstituicoes.sort,
        limit: this.optInstituicoes.items,
        skip: (this.optInstituicoes.page - 1) * this.optInstituicoes.items,
      }
    }).$promise.then(res => {
      let page = this.optInstituicoes.page;
      let items = this.optInstituicoes.items;

      let total = res.count;

      this.optInstituicoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optInstituicoes.start - 1 + items) >= total) {
        this.optInstituicoes.end = total;
      } else {
        this.optInstituicoes.end = Number.parseInt(this.optInstituicoes.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.instituicao = {
          id: x.auxInstituicaoId,
          designacao: x.auxInstituicaoDesignacao,
          pais: x.auxPaisNome,
        };
        x.categoria = {
          id: x.auxCategoriaId,
          designacao: x.auxCategoriaDesignacao
        }
      });

      this.instituicoes = res.data;
      this.optInstituicoes.total = total;
      this.instituicoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler instituições. Verifique a ligação");
    });
  };

  instituicaoSort = keyname => {
    if (this.optInstituicoes.order === keyname)
      this.optInstituicoes.page = 1;
    this.optInstituicoes.order = keyname;
    this.optInstituicoes.sort = this.optInstituicoes.sort === 'asc' ? 'desc' : 'asc';
    this.getInstituicoesForInvestigador();
  };

  instituicaoItem = val => {
    this.optInstituicoes.items = val;
    this.optInstituicoes.page = 1;
    this.getInstituicoesForInvestigador();
  };

  instituicaoPage = sum => {
    this.optInstituicoes.page += sum;
    if (this.optInstituicoes.page < 1)
      this.optInstituicoes.page = 1;
    if (this.optInstituicoes.page > Math.ceil(this.optInstituicoes.total / this.optInstituicoes.items))
      this.optInstituicoes.page = Math.ceil(this.optInstituicoes.total / this.optInstituicoes.items);
    this.getInstituicoesForInvestigador();
  };

  viewInstituicao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./instituicao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Grupos de Investigação
  grupoInvestigacaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let grupoInvestigacao = {};
    let auxGrupoInvestigacaoSelection = undefined;
    if (edit && data != null) {
      grupoInvestigacao = angular.copy(data);
      auxGrupoInvestigacaoSelection = grupoInvestigacao.grupoInvestigacao;
    }
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.grupo.investigacao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Adicionar") + " Grupo de Investigação para investigador";
          scope.grupoInvestigacao = grupoInvestigacao;
          scope.gruposInvestigacao = gruposInvestigacao;

          scope.auxGrupoInvestigacao = {
            selected: auxGrupoInvestigacaoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          scope.removeDate = this.UI.removeDate;
          scope.dateOptions = {
            dataEntrada: {format: 'DD/MM/YYYY'},
            dataSaida: {format: 'DD/MM/YYYY'}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova grupoInvestigacao para investigador
  addGrupoInvestigacao = () => {
    this.grupoInvestigacaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupoInvestigacao) {
          this.gruposInvestigacaoLoading = true;
          let item = angular.copy(ok.grupoInvestigacao);
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupoInvestigacao = angular.copy(ok.auxGrupoInvestigacao.selected);
          // Check if grupoInvestigacao is already there before creating
          this.InvestigatorService.usedPartialDataForModel({investigadorId: this.id, grupoInvestigacaoId: item.grupoInvestigacaoId, dataEntrada: item.dataEntrada}, this.InvestigadorGrupoInvestigacao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Combinação de Grupo de Investigação e Data de Entrada já existe");
              this.gruposInvestigacaoLoading = false;
            } else { // Create it
              this.InvestigatorService.createMultipleData(this.InvestigadorGrupoInvestigacao, [item], this.id, 'investigadorId').then((x) => {
                this.UI.addToast("Grupo de Investigação adicionado com sucesso");
                this.getGruposInvestigacaoForInvestigador();
              }).catch(error => {
                this.gruposInvestigacaoLoading = false;
                this.UI.addToast("Erro ao inserir grupo de investigação. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.gruposInvestigacaoLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita grupo de investigação para investigador
  editGrupoInvestigacao = (x) => {
    this.grupoInvestigacaoModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupoInvestigacao) {
          this.gruposInvestigacaoLoading = true;
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataEntrada = ok.grupoInvestigacao.dataEntrada.format(); // Use text instead of moment
          if (ok.grupoInvestigacao.dataSaida != null && ok.grupoInvestigacao.dataSaida.isValid()) // null, undefined or invalid date
            x.dataSaida = ok.grupoInvestigacao.dataSaida.format(); // Use text instead of moment
          else
            x.dataSaida = null;
          x.observacoes = ok.grupoInvestigacao.observacoes;
          x.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          x.grupoInvestigacao = angular.copy(ok.auxGrupoInvestigacao.selected);

          this.InvestigatorService.updateMultipleData(this.InvestigadorGrupoInvestigacao, [x]).then((res) => {
            this.UI.addToast("Grupo de Investigação atualizado com sucesso");
            this.getGruposInvestigacaoForInvestigador();
          }).catch((error) => {
            this.gruposInvestigacaoLoading = false;
            this.UI.addToast("Erro ao atualizar grupo de investigação. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };


  // Ask confirmation to delete grupoInvestigacao
  confirmDeleteGrupoInvestigacao = (x) => {
    let title = "Eliminar Grupo de Investigação";
    let warning = "Tem a certeza que pretende remover este grupo de investigação para o investigador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeGrupoInvestigacao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeGrupoInvestigacao = (x) => {
    this.gruposInvestigacaoLoading = true;
    // Find again grupoInvestigacao to delete so we can update it
    this.InvestigadorGrupoInvestigacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((grupoInvestigacaoToRemove) => {

      // Remove data
      this.InvestigadorGrupoInvestigacao.deleteById({
        id: grupoInvestigacaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Grupo de Investigação removido com sucesso");
        this.getGruposInvestigacaoForInvestigador();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar grupo de investigação. Verifique se ainda existe.");
      this.getGruposInvestigacaoForInvestigador();
    });
  };

  getGruposInvestigacaoForInvestigador = () => {
    this.gruposInvestigacaoLoading = true;
    let whereLiteral = {
      'InvestigadorGrupoInvestigacao.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optGruposInvestigacao.filter).forEach(f => {
      if (this.optGruposInvestigacao.filter[f])
        where[f] = this.optGruposInvestigacao.filter[f];
    });
    this.InvestigadorGrupoInvestigacao.table({
      params: {
        fields: [
          'InvestigadorGrupoInvestigacao.id as id',
          'InvestigadorGrupoInvestigacao.investigadorId as investigadorId',
          'InvestigadorGrupoInvestigacao.grupoInvestigacaoId as grupoInvestigacaoId',
          'InvestigadorGrupoInvestigacao.dataEntrada as dataEntrada',
          'InvestigadorGrupoInvestigacao.dataSaida as dataSaida',
          'InvestigadorGrupoInvestigacao.criadoPorId as criadoPorId',
          'InvestigadorGrupoInvestigacao.dataCriacao as dataCriacao',
          'InvestigadorGrupoInvestigacao.atualizadoa as atualizadoa',
          'InvestigadorGrupoInvestigacao.observacoes as observacoes',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'GrupoInvestigacao.id as auxGrupoInvestigacaoId',
          'GrupoInvestigacao.designacao as auxGrupoInvestigacaoDesignacao',
          'GrupoInvestigacao.descricao as auxGrupoInvestigacaoDescricao'
        ],
        from: ['InvestigadorGrupoInvestigacao', 'User', 'User', 'GrupoInvestigacao'],
        referencesOrigin: [undefined, undefined, undefined, undefined],
        references: [undefined, 'InvestigadorGrupoInvestigacao.criadoPorId', 'InvestigadorGrupoInvestigacao.atualizadoPorId', 'InvestigadorGrupoInvestigacao.grupoInvestigacaoId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optGruposInvestigacao.order,
        sort: this.optGruposInvestigacao.sort,
        limit: this.optGruposInvestigacao.items,
        skip: (this.optGruposInvestigacao.page - 1) * this.optGruposInvestigacao.items,
      }
    }).$promise.then(res => {
      let page = this.optGruposInvestigacao.page;
      let items = this.optGruposInvestigacao.items;

      let total = res.count;

      this.optGruposInvestigacao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optGruposInvestigacao.start - 1 + items) >= total) {
        this.optGruposInvestigacao.end = total;
      } else {
        this.optGruposInvestigacao.end = Number.parseInt(this.optGruposInvestigacao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.grupoInvestigacao = {
          id: x.auxGrupoInvestigacaoId,
          designacao: x.auxGrupoInvestigacaoDesignacao,
          descricao: x.auxGrupoInvestigacaoDescricao,
        };
      });

      this.gruposInvestigacao = res.data;
      this.optGruposInvestigacao.total = total;
      this.gruposInvestigacaoLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a ligação");
    });
  };

  grupoInvestigacaoSort = keyname => {
    if (this.optGruposInvestigacao.order === keyname)
      this.optGruposInvestigacao.page = 1;
    this.optGruposInvestigacao.order = keyname;
    this.optGruposInvestigacao.sort = this.optGruposInvestigacao.sort === 'asc' ? 'desc' : 'asc';
    this.getGruposInvestigacaoForInvestigador();
  };

  grupoInvestigacaoItem = val => {
    this.optGruposInvestigacao.items = val;
    this.optGruposInvestigacao.page = 1;
    this.getGruposInvestigacaoForInvestigador();
  };

  grupoInvestigacaoPage = sum => {
    this.optGruposInvestigacao.page += sum;
    if (this.optGruposInvestigacao.page < 1)
      this.optGruposInvestigacao.page = 1;
    if (this.optGruposInvestigacao.page > Math.ceil(this.optGruposInvestigacao.total / this.optGruposInvestigacao.items))
      this.optGruposInvestigacao.page = Math.ceil(this.optGruposInvestigacao.total / this.optGruposInvestigacao.items);
    this.getGruposInvestigacaoForInvestigador();
  };

  viewGrupoInvestigacao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./grupo.investigacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataEntrada = moment($scope.data.dataEntrada).isValid() ? moment($scope.data.dataEntrada).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.dataSaida = moment($scope.data.dataSaida).isValid() ? moment($scope.data.dataSaida).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Publicações
  getPublicacoesForInvestigador = () => {
    this.publicacoesLoading = true;
    let whereLiteral = {
      'PublicacaoAutor.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optPublicacoes.filter).forEach(f => {
      if (this.optPublicacoes.filter[f])
        where[f] = this.optPublicacoes.filter[f];
    });
    this.PublicacaoAutor.tableInvestigador({
      params: {
        fields: [
          'Publicacao.id as auxPublicacaoId',
          'Publicacao.titulo as auxPublicacaoTitulo',
          'Publicacao.ano as auxPublicacaoAno',
          'Publicacao.ok as auxPublicacaoOk',
          'PublicacaoTipo.id as auxPublicacaoTipoId',
          'PublicacaoTipo.designacao as auxPublicacaoTipoDesignacao'
        ],
        from: ['PublicacaoAutor', 'Publicacao', 'PublicacaoTipo'],
        referencesOrigin: [undefined, undefined, 'PublicacaoTipo.id'],
        references: [undefined, 'PublicacaoAutor.publicacaoId', 'Publicacao.tipoId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optPublicacoes.order,
        sort: this.optPublicacoes.sort,
        limit: this.optPublicacoes.items,
        skip: (this.optPublicacoes.page - 1) * this.optPublicacoes.items,
      }
    }).$promise.then(res => {
      let page = this.optPublicacoes.page;
      let items = this.optPublicacoes.items;

      let total = res.count;

      this.optPublicacoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optPublicacoes.start - 1 + items) >= total) {
        this.optPublicacoes.end = total;
      } else {
        this.optPublicacoes.end = Number.parseInt(this.optPublicacoes.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.publicacao = {
          id: x.auxPublicacaoId,
          titulo: x.auxPublicacaoTitulo,
          ano: x.auxPublicacaoAno,
          ok: x.auxPublicacaoOk
        };
        x.tipo = {
          id: x.auxPublicacaoTipoId,
          designacao: x.auxPublicacaoTipoDesignacao
        }
      });

      this.publicacoes = res.data;
      this.optPublicacoes.total = total;
      this.publicacoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler publicações. Verifique a ligação");
    });
  };

  publicacaoSort = keyname => {
    if (this.optPublicacoes.order === keyname)
      this.optPublicacoes.page = 1;
    this.optPublicacoes.order = keyname;
    this.optPublicacoes.sort = this.optPublicacoes.sort === 'asc' ? 'desc' : 'asc';
    this.getPublicacoesForInvestigador();
  };

  publicacaoItem = val => {
    this.optPublicacoes.items = val;
    this.optPublicacoes.page = 1;
    this.getPublicacoesForInvestigador();
  };

  publicacaoPage = sum => {
    this.optPublicacoes.page += sum;
    if (this.optPublicacoes.page < 1)
      this.optPublicacoes.page = 1;
    if (this.optPublicacoes.page > Math.ceil(this.optPublicacoes.total / this.optPublicacoes.items))
      this.optPublicacoes.page = Math.ceil(this.optPublicacoes.total / this.optPublicacoes.items);
    this.getPublicacoesForInvestigador();
  };

  viewPublicacao = x => {
    this.$state.go('app.publicacao.details', {id: x.auxPublicacaoId});
  };


  // Revistas
  getRevistasForInvestigador = () => {
    this.revistasLoading = true;
    let whereLiteral = {
      'RevistaEquipaEditorial.investigadorId': this.id
    };
    let where = {};
    Object.keys(this.optRevistas.filter).forEach(f => {
      if (this.optRevistas.filter[f])
        where[f] = this.optRevistas.filter[f];
    });
    this.RevistaEquipaEditorial.tableInvestigador({
      params: {
        fields: [
          'Revista.id as auxRevistaId',
          'Revista.nome as auxRevistaNome',
          'Revista.issn as auxRevistaIssn',
          'RevistaEquipaEditorial.dataEntrada as dataEntrada',
          'RevistaEquipaEditorial.dataSaida as dataSaida',
          'RevistaEquipaEditorialFuncao.id as auxRevistaEquipaEditorialFuncaoId',
          'RevistaEquipaEditorialFuncao.designacao as auxRevistaEquipaEditorialFuncaoDesignacao'
        ],
        from: ['RevistaEquipaEditorial', 'Revista', 'RevistaEquipaEditorialFuncao'],
        referencesOrigin: [undefined, undefined, 'RevistaEquipaEditorialFuncao.id'],
        references: [undefined, 'RevistaEquipaEditorial.revistaId', 'RevistaEquipaEditorial.funcaoId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optRevistas.order,
        sort: this.optRevistas.sort,
        limit: this.optRevistas.items,
        skip: (this.optRevistas.page - 1) * this.optRevistas.items,
      }
    }).$promise.then(res => {
      let page = this.optRevistas.page;
      let items = this.optRevistas.items;

      let total = res.count;

      this.optRevistas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optRevistas.start - 1 + items) >= total) {
        this.optRevistas.end = total;
      } else {
        this.optRevistas.end = Number.parseInt(this.optRevistas.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.revista = {
          id: x.auxRevistaId,
          titulo: x.auxRevistaNome,
          ano: x.auxRevistaIssn
        };
        x.funcao = {
          id: x.auxRevistaEquipaEditorialFuncaoId,
          designacao: x.auxRevistaEquipaEditorialDesignacao
        }
      });

      this.revistas = res.data;
      this.optRevistas.total = total;
      this.revistasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler revistas. Verifique a ligação");
    });
  };

  revistaSort = keyname => {
    if (this.optRevistas.order === keyname)
      this.optRevistas.page = 1;
    this.optRevistas.order = keyname;
    this.optRevistas.sort = this.optRevistas.sort === 'asc' ? 'desc' : 'asc';
    this.getRevistasForInvestigador();
  };

  revistaItem = val => {
    this.optRevistas.items = val;
    this.optRevistas.page = 1;
    this.getRevistasForInvestigador();
  };

  revistaPage = sum => {
    this.optRevistas.page += sum;
    if (this.optRevistas.page < 1)
      this.optRevistas.page = 1;
    if (this.optRevistas.page > Math.ceil(this.optRevistas.total / this.optRevistas.items))
      this.optRevistas.page = Math.ceil(this.optRevistas.total / this.optRevistas.items);
    this.getRevistasForInvestigador();
  };

  viewRevista = x => {
    this.$state.go('app.revista.details', {id: x.auxRevistaId});
  };


  // Eventos
  getEventosForInvestigador = () => {
    this.eventosLoading = true;
    let whereOrLiteral = [
      {key: 'EventoOrganizacao.investigadorId', value: this.id},
      {key: 'Evento.responsavelId', value: this.id}
    ];
    let where = {};
    Object.keys(this.optEventos.filter).forEach(f => {
      if (this.optEventos.filter[f])
        where[f] = this.optEventos.filter[f];
    });
    this.EventoOrganizacao.tableInvestigador({
      params: {
        fields: [
          'Evento.id as auxEventoId',
          'Evento.designacao as auxEventoDesignacao',
          'Evento.local as auxEventoLocal',
          'Evento.ano as auxEventoAno',
          'Evento.www as auxEventoWww',
        ],
        from: ['EventoOrganizacao', 'Evento'],
        referencesOrigin: [undefined, undefined],
        references: [undefined, 'EventoOrganizacao.eventoId'],
        where: where,
        whereOrLiteral: whereOrLiteral,
        order: this.optEventos.order,
        sort: this.optEventos.sort,
        limit: this.optEventos.items,
        skip: (this.optEventos.page - 1) * this.optEventos.items,
      }
    }).$promise.then(res => {
      let page = this.optEventos.page;
      let items = this.optEventos.items;

      let total = res.count;

      this.optEventos.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optEventos.start - 1 + items) >= total) {
        this.optEventos.end = total;
      } else {
        this.optEventos.end = Number.parseInt(this.optEventos.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.evento = {
          id: x.auxEventoId,
          designacao: x.auxEventoDesignacao,
          local: x.auxEventoLocal,
          ano: x.auxEventoAno,
          www: x.auxEventoWww
        };
      });

      this.eventos = res.data;
      this.optEventos.total = total;
      this.eventosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler eventos. Verifique a ligação");
    });
  };

  eventoSort = keyname => {
    if (this.optEventos.order === keyname)
      this.optEventos.page = 1;
    this.optEventos.order = keyname;
    this.optEventos.sort = this.optEventos.sort === 'asc' ? 'desc' : 'asc';
    this.getEventosForInvestigador();
  };

  eventoItem = val => {
    this.optEventos.items = val;
    this.optEventos.page = 1;
    this.getEventosForInvestigador();
  };

  eventoPage = sum => {
    this.optEventos.page += sum;
    if (this.optEventos.page < 1)
      this.optEventos.page = 1;
    if (this.optEventos.page > Math.ceil(this.optEventos.total / this.optEventos.items))
      this.optEventos.page = Math.ceil(this.optEventos.total / this.optEventos.items);
    this.getEventosForInvestigador();
  };

  viewEvento = x => {
    this.$state.go('app.evento.details', {id: x.auxEventoId});
  };


  // Projetos
  getProjetosForInvestigador = () => {
    this.projetosLoading = true;
    let whereOrLiteral = [
      {key: 'ProjetoEquipa.investigadorId', value: this.id},
      {key: 'Projeto.investigadorId', value: this.id},
      {key: 'Projeto.coInvestigadorId', value: this.id}
    ];
    let where = {};
    Object.keys(this.optProjetos.filter).forEach(f => {
      if (this.optProjetos.filter[f])
        where[f] = this.optProjetos.filter[f];
    });
    this.ProjetoEquipa.tableInvestigador({
      params: {
        fields: [
          'Projeto.id as auxProjetoId',
          'Projeto.acronimo as auxProjetoAcronimo',
          'Projeto.titulo as auxProjetoTitulo',
          'Projeto.dataInicio as auxProjetoDataInicio',
          'Projeto.dataFim as auxProjetoDataFim',
          'Projeto.www as auxProjetoWww',
          'ProjetoEstado.id as auxProjetoEstadoId',
          'ProjetoEstado.designacao as auxProjetoEstadoDesignacao'
        ],
        from: ['ProjetoEquipa', 'Projeto', 'ProjetoEstado'],
        referencesOrigin: [undefined, undefined, 'ProjetoEstado.id'],
        references: [undefined, 'ProjetoEquipa.projetoId', 'Projeto.estadoId'],
        where: where,
        whereOrLiteral: whereOrLiteral,
        order: this.optProjetos.order,
        sort: this.optProjetos.sort,
        limit: this.optProjetos.items,
        skip: (this.optProjetos.page - 1) * this.optProjetos.items,
      }
    }).$promise.then(res => {
      let page = this.optProjetos.page;
      let items = this.optProjetos.items;

      let total = res.count;

      this.optProjetos.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optProjetos.start - 1 + items) >= total) {
        this.optProjetos.end = total;
      } else {
        this.optProjetos.end = Number.parseInt(this.optProjetos.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.projeto = {
          id: x.auxProjetoId,
          acronimo: x.auxProjetoAcronimo,
          titulo: x.auxProjetoTitulo,
          dataInicio: x.auxProjetoDataInicio,
          dataFim: x.auxProjetoDataFim,
          www: x.auxProjetoWww,
        };
        x.estado = {
          id: x.auxProjetoEstadoId,
          designacao: x.auxProjetoEstadoDesignacao
        }
      });

      this.projetos = res.data;
      this.optProjetos.total = total;
      this.projetosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler projetos. Verifique a ligação");
    });
  };

  projetoSort = keyname => {
    if (this.optProjetos.order === keyname)
      this.optProjetos.page = 1;
    this.optProjetos.order = keyname;
    this.optProjetos.sort = this.optProjetos.sort === 'asc' ? 'desc' : 'asc';
    this.getProjetosForInvestigador();
  };

  projetoItem = val => {
    this.optProjetos.items = val;
    this.optProjetos.page = 1;
    this.getProjetosForInvestigador();
  };

  projetoPage = sum => {
    this.optProjetos.page += sum;
    if (this.optProjetos.page < 1)
      this.optProjetos.page = 1;
    if (this.optProjetos.page > Math.ceil(this.optProjetos.total / this.optProjetos.items))
      this.optProjetos.page = Math.ceil(this.optProjetos.total / this.optProjetos.items);
    this.getProjetosForInvestigador();
  };

  viewProjeto = x => {
    this.$state.go('app.projeto.details', {id: x.auxProjetoId});
  };


  // Produtos
  getProdutosForInvestigador = () => {
    this.produtosLoading = true;
    let whereLiteral = {
      'ProdutoInvestigador.investigadorId': this.id
    };

    let where = {};
    Object.keys(this.optProdutos.filter).forEach(f => {
      if (this.optProdutos.filter[f])
        where[f] = this.optProdutos.filter[f];
    });
    this.ProdutoInvestigador.tableInvestigador({
      params: {
        fields: [
          'Produto.id as auxProdutoId',
          'Produto.designacao as auxProdutoDesignacao',
          'Produto.ano as auxProdutoAno',
          'Produto.www as auxProdutoWww',
          'ProdutoTipo.id as auxProdutoTipoId',
          'ProdutoTipo.designacao as auxProdutoTipoDesignacao'
        ],
        from: ['ProdutoInvestigador', 'Produto', 'ProdutoTipo'],
        referencesOrigin: [undefined, undefined, 'ProdutoTipo.id'],
        references: [undefined, 'ProdutoInvestigador.produtoId', 'Produto.produtoTipoId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optProdutos.order,
        sort: this.optProdutos.sort,
        limit: this.optProdutos.items,
        skip: (this.optProdutos.page - 1) * this.optProdutos.items,
      }
    }).$promise.then(res => {
      let page = this.optProdutos.page;
      let items = this.optProdutos.items;

      let total = res.count;

      this.optProdutos.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optProdutos.start - 1 + items) >= total) {
        this.optProdutos.end = total;
      } else {
        this.optProdutos.end = Number.parseInt(this.optProdutos.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.produto = {
          id: x.auxProdutoId,
          designacao: x.auxProdutoDesignacao,
          ano: x.auxProdutoAno,
          www: x.auxProdutoWww,
        };
        x.tipo = {
          id: x.auxProdutoTipoId,
          designacao: x.auxProdutoTipoDesignacao
        }
      });

      this.produtos = res.data;
      this.optProdutos.total = total;
      this.produtosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler produtos. Verifique a ligação");
    });
  };

  produtoSort = keyname => {
    if (this.optProdutos.order === keyname)
      this.optProdutos.page = 1;
    this.optProdutos.order = keyname;
    this.optProdutos.sort = this.optProdutos.sort === 'asc' ? 'desc' : 'asc';
    this.getProdutosForInvestigador();
  };

  produtoItem = val => {
    this.optProdutos.items = val;
    this.optProdutos.page = 1;
    this.getProdutosForInvestigador();
  };

  produtoPage = sum => {
    this.optProdutos.page += sum;
    if (this.optProdutos.page < 1)
      this.optProdutos.page = 1;
    if (this.optProdutos.page > Math.ceil(this.optProdutos.total / this.optProdutos.items))
      this.optProdutos.page = Math.ceil(this.optProdutos.total / this.optProdutos.items);
    this.getProdutosForInvestigador();
  };

  viewProduto = x => {
    this.$state.go('app.produto.details', {id: x.auxProdutoId});
  };


  // Formações
  getFormacoesForInvestigador = () => {
    this.formacoesLoading = true;
    let whereLiteral = {
      'Formacao.investigadorId': this.id
    };

    let where = {};
    Object.keys(this.optFormacoes.filter).forEach(f => {
      if (this.optFormacoes.filter[f])
        where[f] = this.optFormacoes.filter[f];
    });
    this.Formacao.table({
      params: {
        fields: [
          'Formacao.id as id',
          'Formacao.investigadorId as investigadorId',
          'Formacao.designacao as designacao',
          'Formacao.dataInicio as dataInicio',
          'Formacao.dataFim as dataFim',
          'Formacao.horas as horas',
          'User.name as criadoPorName',
          'Instituicao.id as auxInstituicaoId',
          'Instituicao.designacao as auxInstituicaoDesignacao'
        ],
        from: ['Formacao', 'User', 'Instituicao'],
        referencesOrigin: [undefined, undefined, 'Instituicao.id'],
        references: [undefined, 'Formacao.criadoPorId', 'Formacao.instituicaoId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optFormacoes.order,
        sort: this.optFormacoes.sort,
        limit: this.optFormacoes.items,
        skip: (this.optFormacoes.page - 1) * this.optFormacoes.items,
      }
    }).$promise.then(res => {
      let page = this.optFormacoes.page;
      let items = this.optFormacoes.items;

      let total = res.count;

      this.optFormacoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optFormacoes.start - 1 + items) >= total) {
        this.optFormacoes.end = total;
      } else {
        this.optFormacoes.end = Number.parseInt(this.optFormacoes.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.instituicao = {
          id: x.auxInstituicaoId,
          designacao: x.auxInstituicaoDesignacao
        }
      });

      this.formacoes = res.data;
      this.optFormacoes.total = total;
      this.formacoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler formações. Verifique a ligação");
    });
  };

  formacaoSort = keyname => {
    if (this.optFormacoes.order === keyname)
      this.optFormacoes.page = 1;
    this.optFormacoes.order = keyname;
    this.optFormacoes.sort = this.optFormacoes.sort === 'asc' ? 'desc' : 'asc';
    this.getFormacoesForInvestigador();
  };

  formacaoItem = val => {
    this.optFormacoes.items = val;
    this.optFormacoes.page = 1;
    this.getFormacoesForInvestigador();
  };

  formacaoPage = sum => {
    this.optFormacoes.page += sum;
    if (this.optFormacoes.page < 1)
      this.optFormacoes.page = 1;
    if (this.optFormacoes.page > Math.ceil(this.optFormacoes.total / this.optFormacoes.items))
      this.optFormacoes.page = Math.ceil(this.optFormacoes.total / this.optFormacoes.items);
    this.getFormacoesForInvestigador();
  };

  viewFormacao = x => {
    this.$state.go('app.formacao.details', {id: x.id});
  };


  // Orientações
  getOrientacoesForInvestigador = () => {
    this.orientacoesLoading = true;
    let whereLiteral = {
      'OrientacaoInvestigador.investigadorId': this.id
    };

    let where = {};
    Object.keys(this.optOrientacoes.filter).forEach(f => {
      if (this.optOrientacoes.filter[f])
        where[f] = this.optOrientacoes.filter[f];
    });
    this.OrientacaoInvestigador.tableInvestigador({
      params: {
        fields: [
          'Orientacao.id as auxOrientacaoId',
          'Orientacao.titulo as auxOrientacaoTitulo',
          'Orientacao.designacao as auxOrientacaoDesignacao',
          'Orientacao.dataInicio as auxOrientacaoDataInicio',
          'Orientacao.dataFim as auxOrientacaoDataFim',
          'OrientacaoTipo.id as auxOrientacaoTipoId',
          'OrientacaoTipo.designacao as auxOrientacaoTipoDesignacao',
          'Orientando.id as auxOrientandoId',
          'Orientando.nome as auxOrientandoNome',
        ],
        from: ['OrientacaoInvestigador', 'Orientacao', 'OrientacaoTipo', 'Orientando'],
        referencesOrigin: [undefined, undefined, 'OrientacaoTipo.id', 'Orientando.id'],
        references: [undefined, 'OrientacaoInvestigador.orientacaoId', 'Orientacao.orientacaoTipoId', 'Orientacao.orientandoId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optOrientacoes.order,
        sort: this.optOrientacoes.sort,
        limit: this.optOrientacoes.items,
        skip: (this.optOrientacoes.page - 1) * this.optOrientacoes.items,
      }
    }).$promise.then(res => {
      let page = this.optOrientacoes.page;
      let items = this.optOrientacoes.items;

      let total = res.count;

      this.optOrientacoes.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optOrientacoes.start - 1 + items) >= total) {
        this.optOrientacoes.end = total;
      } else {
        this.optOrientacoes.end = Number.parseInt(this.optOrientacoes.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.orientacao = {
          id: x.auxOrientacaoId,
          titulo: x.auxOrientacaoTitulo,
          designacao: x.auxOrientacaoDesignacao,
          dataInicio: x.auxOrientacaoDataInicio,
          dataFim: x.auxOrientacaoDataFim
        };
        x.tipo = {
          id: x.auxOrientacaoTipoId,
          designacao: x.auxOrientacaoTipoDesignacao
        };
        x.orientando = {
          id: x.auxOrientandoId,
          nome: x.auxOrientandoNome
        }
      });

      this.orientacoes = res.data;
      this.optOrientacoes.total = total;
      this.orientacoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler orientações. Verifique a ligação");
    });
  };

  orientacaoSort = keyname => {
    if (this.optOrientacoes.order === keyname)
      this.optOrientacoes.page = 1;
    this.optOrientacoes.order = keyname;
    this.optOrientacoes.sort = this.optOrientacoes.sort === 'asc' ? 'desc' : 'asc';
    this.getOrientacoesForInvestigador();
  };

  orientacaoItem = val => {
    this.optOrientacoes.items = val;
    this.optOrientacoes.page = 1;
    this.getOrientacoesForInvestigador();
  };

  orientacaoPage = sum => {
    this.optOrientacoes.page += sum;
    if (this.optOrientacoes.page < 1)
      this.optOrientacoes.page = 1;
    if (this.optOrientacoes.page > Math.ceil(this.optOrientacoes.total / this.optOrientacoes.items))
      this.optOrientacoes.page = Math.ceil(this.optOrientacoes.total / this.optOrientacoes.items);
    this.getOrientacoesForInvestigador();
  };

  viewOrientacao = x => {
    this.$state.go('app.orientacao.details', {id: x.auxOrientacaoId});
  };


  // Serviços
  getServicosForInvestigador = () => {
    this.servicosLoading = true;
    let whereOrLiteral = [
      {key: 'ServicoParticipante.investigadorId', value: this.id},
      {key: 'Servico.investigadorId', value: this.id}
    ];

    let where = {};
    Object.keys(this.optServicos.filter).forEach(f => {
      if (this.optServicos.filter[f])
        where[f] = this.optServicos.filter[f];
    });
    this.ServicoParticipante.tableInvestigador({
      params: {
        fields: [
          'Servico.id as auxServicoId',
          'Servico.acronimo as auxServicoAcronimo',
          'Servico.titulo as auxServicoTitulo',
          'EntidadeFinanciadora.id as auxEntidadeFinanciadoraId',
          'EntidadeFinanciadora.designacao as auxEntidadeFinanciadoraDesignacao',
          'Setor.id as auxSetorId',
          'Setor.designacao as auxSetorDesignacao'
        ],
        from: ['ServicoParticipante', 'Servico', 'EntidadeFinanciadora', 'Setor'],
        referencesOrigin: [undefined, undefined, 'EntidadeFinanciadora.id', 'Setor.id'],
        references: [undefined, 'ServicoParticipante.servicoId', 'Servico.entidadeFinanciadoraId', 'Servico.setorId'],
        where: where,
        whereOrLiteral: whereOrLiteral,
        order: this.optServicos.order,
        sort: this.optServicos.sort,
        limit: this.optServicos.items,
        skip: (this.optServicos.page - 1) * this.optServicos.items,
      }
    }).$promise.then(res => {
      let page = this.optServicos.page;
      let items = this.optServicos.items;

      let total = res.count;

      this.optServicos.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optServicos.start - 1 + items) >= total) {
        this.optServicos.end = total;
      } else {
        this.optServicos.end = Number.parseInt(this.optServicos.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.servico = {
          id: x.auxServicoId,
          acronimo: x.auxServicoAcronimo,
          titulo: x.auxServicoTitulo,
        };
        x.entidadeFinanciadora = {
          id: x.auxEntidadeFinanciadoraId,
          designacao: x.auxEntidadeFinanciadoraDesignacao
        };
        x.setor = {
          id: x.auxSetorId,
          designacao: x.auxSetorDesignacao
        };
      });

      this.servicos = res.data;
      this.optServicos.total = total;
      this.servicosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler serviços. Verifique a ligação");
    });
  };

  servicoSort = keyname => {
    if (this.optServicos.order === keyname)
      this.optServicos.page = 1;
    this.optServicos.order = keyname;
    this.optServicos.sort = this.optServicos.sort === 'asc' ? 'desc' : 'asc';
    this.getServicosForInvestigador();
  };

  servicoItem = val => {
    this.optServicos.items = val;
    this.optServicos.page = 1;
    this.getServicosForInvestigador();
  };

  servicoPage = sum => {
    this.optServicos.page += sum;
    if (this.optServicos.page < 1)
      this.optServicos.page = 1;
    if (this.optServicos.page > Math.ceil(this.optServicos.total / this.optServicos.items))
      this.optServicos.page = Math.ceil(this.optServicos.total / this.optServicos.items);
    this.getServicosForInvestigador();
  };

  viewServico = x => {
    this.$state.go('app.servico.details', {id: x.auxServicoId});
  };


  // Painéis
  getPaineisForInvestigador = () => {
    this.paineisLoading = true;
    let whereLiteral = {
      'Painel.investigadorId': this.id
    };

    let where = {};
    Object.keys(this.optPaineis.filter).forEach(f => {
      if (this.optPaineis.filter[f])
        where[f] = this.optPaineis.filter[f];
    });
    this.Painel.table({
      params: {
        fields: [
          'Painel.id as id',
          'Painel.investigadorId as investigadorId',
          'Painel.identificacao as identificacao',
          'Painel.ano as ano',
          'User.name as criadoPorName',
          'EntidadeFinanciadora.id as auxEntidadeFinanciadoraId',
          'EntidadeFinanciadora.designacao as auxEntidadeFinanciadoraDesignacao',
          'Ambito.id as auxAmbitoId',
          'Ambito.designacao as auxAmbitoDesignacao',
          'Abrangencia.id as auxAbrangenciaId',
          'Abrangencia.designacao as auxAbrangenciaDesignacao',
        ],
        from: ['Painel', 'User', 'EntidadeFinanciadora', 'Ambito', 'Abrangencia'],
        referencesOrigin: [undefined, undefined, 'EntidadeFinanciadora.id', 'Ambito.id', 'Abrangencia.id'],
        references: [undefined, 'Painel.criadoPorId', 'Painel.entidadeFinanciadoraId', 'Painel.ambitoId', 'Painel.abrangenciaId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optPaineis.order,
        sort: this.optPaineis.sort,
        limit: this.optPaineis.items,
        skip: (this.optPaineis.page - 1) * this.optPaineis.items,
      }
    }).$promise.then(res => {
      let page = this.optPaineis.page;
      let items = this.optPaineis.items;

      let total = res.count;

      this.optPaineis.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optPaineis.start - 1 + items) >= total) {
        this.optPaineis.end = total;
      } else {
        this.optPaineis.end = Number.parseInt(this.optPaineis.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.entidadeFinanciadora = {
          id: x.auxEntidadeFinanciadoraId,
          designacao: x.auxEntidadeFinanciadoraDesignacao
        };
        x.ambito = {
          id: x.auxAmbitoId,
          designacao: x.auxAmbitoDesignacao
        };
        x.abrangencia = {
          id: x.auxAbrangenciaId,
          designacao: x.auxAbrangenciaDesignacao
        };
      });

      this.paineis = res.data;
      this.optPaineis.total = total;
      this.paineisLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler painéis. Verifique a ligação");
    });
  };

  painelSort = keyname => {
    if (this.optPaineis.order === keyname)
      this.optPaineis.page = 1;
    this.optPaineis.order = keyname;
    this.optPaineis.sort = this.optPaineis.sort === 'asc' ? 'desc' : 'asc';
    this.getPaineisForInvestigador();
  };

  painelItem = val => {
    this.optPaineis.items = val;
    this.optPaineis.page = 1;
    this.getPaineisForInvestigador();
  };

  painelPage = sum => {
    this.optPaineis.page += sum;
    if (this.optPaineis.page < 1)
      this.optPaineis.page = 1;
    if (this.optPaineis.page > Math.ceil(this.optPaineis.total / this.optPaineis.items))
      this.optPaineis.page = Math.ceil(this.optPaineis.total / this.optPaineis.items);
    this.getPaineisForInvestigador();
  };

  viewPainel = x => {
    this.$state.go('app.painel.details', {id: x.id});
  };


  // Networks
  getNetworksForInvestigador = () => {
    this.networksLoading = true;
    let whereLiteral = {
      'Network.investigadorId': this.id
    };

    let where = {};
    Object.keys(this.optNetworks.filter).forEach(f => {
      if (this.optNetworks.filter[f])
        where[f] = this.optNetworks.filter[f];
    });
    this.Network.table({
      params: {
        fields: [
          'Network.id as id',
          'Network.investigadorId as investigadorId',
          'Network.designacao as designacao',
          'Network.anoInicio as anoInicio',
          'Network.anoFim as anoFim',
          'Network.www as www',
          'User.name as criadoPorName',
          'Papel.id as auxPapelId',
          'Papel.designacao as auxPapelDesignacao',
          'Abrangencia.id as auxAbrangenciaId',
          'Abrangencia.designacao as auxAbrangenciaDesignacao',
        ],
        from: ['Network', 'User', 'Papel', 'Abrangencia'],
        referencesOrigin: [undefined, undefined, 'Papel.id', 'Abrangencia.id'],
        references: [undefined, 'Network.criadoPorId', 'Network.papelId', 'Network.abrangenciaId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optNetworks.order,
        sort: this.optNetworks.sort,
        limit: this.optNetworks.items,
        skip: (this.optNetworks.page - 1) * this.optNetworks.items,
      }
    }).$promise.then(res => {
      let page = this.optNetworks.page;
      let items = this.optNetworks.items;

      let total = res.count;

      this.optNetworks.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optNetworks.start - 1 + items) >= total) {
        this.optNetworks.end = total;
      } else {
        this.optNetworks.end = Number.parseInt(this.optNetworks.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.papel = {
          id: x.auxPapelId,
          designacao: x.auxPapelDesignacao
        };
        x.abrangencia = {
          id: x.auxAbrangenciaId,
          designacao: x.auxAbrangenciaDesignacao
        };
      });

      this.networks = res.data;
      this.optNetworks.total = total;
      this.networksLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler redes. Verifique a ligação");
    });
  };

  networkSort = keyname => {
    if (this.optNetworks.order === keyname)
      this.optNetworks.page = 1;
    this.optNetworks.order = keyname;
    this.optNetworks.sort = this.optNetworks.sort === 'asc' ? 'desc' : 'asc';
    this.getNetworksForInvestigador();
  };

  networkItem = val => {
    this.optNetworks.items = val;
    this.optNetworks.page = 1;
    this.getNetworksForInvestigador();
  };

  networkPage = sum => {
    this.optNetworks.page += sum;
    if (this.optNetworks.page < 1)
      this.optNetworks.page = 1;
    if (this.optNetworks.page > Math.ceil(this.optNetworks.total / this.optNetworks.items))
      this.optNetworks.page = Math.ceil(this.optNetworks.total / this.optNetworks.items);
    this.getNetworksForInvestigador();
  };

  viewNetwork = x => {
    this.$state.go('app.network.details', {id: x.id});
  };

  // Get all tooltips (so it doesn't fetch all the time)
  getTooltips = () => {
    this.InvestigadorTooltip.find({}).$promise.then((tooltips) => {
      this.tooltips = tooltips;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na obtenção de ajuda. Não poderá consultar ajudas ao preenchimento. Verifique a ligação");
    });
  };

  showInfo = (id) => {
    let tooltip = this.tooltips.find(x => x.id === id);

    if (!tooltip) {
      this.UI.addToast("Ajuda não encontrada");
      return;
    }

    let options = {
      size: 'md',
      template: require('./info.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = tooltip.tag;
        scope.message = tooltip.message;

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then(() => {}).catch(() => {}); // Do nothing
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.InvestigatorService.canRead('investigadorRead', true, 'investigadorReadAny', [this.data.userId]);
  canEditGeneral = () => this.InvestigatorService.canEdit('investigadorEdit', true, 'investigadorEditAny', [this.data.userId]);

  canReadAdicional = () => this.InvestigatorService.canRead('investigadorReadAdicional', false, 'investigadorReadAdicionalAny', [this.data.userId]);
  canEditAdicional = () => this.InvestigatorService.canEdit('investigadorEditAdicional', false, 'investigadorEditAdicionalAny', [this.data.userId]);

  canReadGrauAcademico = () => this.InvestigatorService.canRead('investigadorReadGrauAcademico', true, 'investigadorReadGrauAcademicoAny', [this.data.userId]);
  canEditGrauAcademico = () => this.InvestigatorService.canEdit('investigadorEditGrauAcademico', true, 'investigadorEditGrauAcademicoAny', [this.data.userId]);

  canReadEntradaSaida = () => this.InvestigatorService.canRead('investigadorReadEntradaSaida', true, 'investigadorReadEntradaSaidaAny', [this.data.userId]);
  canEditEntradaSaida = () => this.InvestigatorService.canEdit('investigadorEditEntradaSaida', true, 'investigadorEditEntradaSaidaAny', [this.data.userId]);

  canReadCitacao = () => this.InvestigatorService.canRead('investigadorReadCitacao', true, 'investigadorReadCitacaoAny', [this.data.userId]);
  canEditCitacao = () => this.InvestigatorService.canEdit('investigadorEditCitacao', true, 'investigadorEditCitacaoAny', [this.data.userId]);

  canReadTipoInvestigador = () => this.InvestigatorService.canRead('investigadorReadTipoInvestigador', true, 'investigadorReadTipoInvestigadorAny', [this.data.userId]);
  canEditTipoInvestigador = () => this.InvestigatorService.canEdit('investigadorEditTipoInvestigador', true, 'investigadorEditTipoInvestigadorAny', [this.data.userId]);

  canReadHValue = () => this.InvestigatorService.canRead('investigadorReadHValue', true, 'investigadorReadHValueAny', [this.data.userId]);
  canEditHValue = () => this.InvestigatorService.canEdit('investigadorEditHValue', true, 'investigadorEditHValueAny', [this.data.userId]);

  canReadContratacao = () => this.InvestigatorService.canRead('investigadorReadContratacao', true, 'investigadorReadContratacaoAny', [this.data.userId]);
  canEditContratacao = () => this.InvestigatorService.canEdit('investigadorEditContratacao', true, 'investigadorEditContratacaoAny', [this.data.userId]);

  canReadAtividade = () => this.InvestigatorService.canRead('investigadorReadAtividade', true, 'investigadorReadAtividadeAny', [this.data.userId]);
  canEditAtividade = () => this.InvestigatorService.canEdit('investigadorEditAtividade', true, 'investigadorEditAtividadeAny', [this.data.userId]);

  canReadParticipacaoGestao = () => this.InvestigatorService.canRead('investigadorReadParticipacaoGestao', true, 'investigadorReadParticipacaoGestaoAny', [this.data.userId]);
  canEditParticipacaoGestao = () => this.InvestigatorService.canEdit('investigadorEditParticipacaoGestao', true, 'investigadorEditParticipacaoGestaoAny', [this.data.userId]);

  canReadGrupoInvestigacao = () => this.InvestigatorService.canRead('investigadorReadGrupoInvestigacao', true, 'investigadorReadGrupoInvestigacaoAny', [this.data.userId]);
  canEditGrupoInvestigacao = () => this.InvestigatorService.canEdit('investigadorEditGrupoInvestigacao', true, 'investigadorEditGrupoInvestigacaoAny', [this.data.userId]);

  canReadInstituicao = () => this.InvestigatorService.canRead('investigadorReadInstituicao', true, 'investigadorReadInstituicaoAny', [this.data.userId]);
  canEditInstituicao = () => this.InvestigatorService.canEdit('investigadorEditInstituicao', true, 'investigadorEditInstituicaoAny', [this.data.userId]);

  canReadPublicacao = () => this.InvestigatorService.canRead('investigadorReadPublicacao', true, 'investigadorReadPublicacaoAny', [this.data.userId]);
  canImportPublicacao = () => this.InvestigatorService.canEdit('investigadorImportPublicacao', true, 'investigadorImportPublicacaoAny', [this.data.userId]);

  canReadRevista = () => this.InvestigatorService.canRead('investigadorReadRevista', true, 'investigadorReadRevistaAny', [this.data.userId]);
  canReadEvento = () => this.InvestigatorService.canRead('investigadorReadEvento', true, 'investigadorReadEventoAny', [this.data.userId]);
  canReadProjeto = () => this.InvestigatorService.canRead('investigadorReadProjeto', true, 'investigadorReadProjetoAny', [this.data.userId]);
  canReadProduto = () => this.InvestigatorService.canRead('investigadorReadProduto', true, 'investigadorReadProdutoAny', [this.data.userId]);
  canReadFormacao = () => this.InvestigatorService.canRead('investigadorReadFormacao', true, 'investigadorReadFormacaoAny', [this.data.userId]);
  canReadOrientacao = () => this.InvestigatorService.canRead('investigadorReadOrientacao', true, 'investigadorReadOrientacaoAny', [this.data.userId]);
  canReadServico = () => this.InvestigatorService.canRead('investigadorReadServico', true, 'investigadorReadServicoAny', [this.data.userId]);
  canReadPainel = () => this.InvestigatorService.canRead('investigadorReadPainel', true, 'investigadorReadPainelAny', [this.data.userId]);
  canReadRede = () => this.InvestigatorService.canRead('investigadorReadRede', true, 'investigadorReadRedeAny', [this.data.userId]);

  canReadInformacaoPrivada = () => this.InvestigatorService.canRead('investigadorReadPrivate', false, 'investigadorReadPrivateAny', [this.data.userId]);
}

InvestigatorDetailsController.$inject = ['$q', '$state', '$scope', 'FileUploader', 'AuthenticationService', 'UIService', 'InvestigatorService', 'Investigador', 'Genero', 'Pais', 'InvestigadorTipoInvestigador', 'InvestigadorTipo', 'InvestigadorGrauAcademico', 'InvestigadorHValue', 'InvestigadorCitacao', 'InvestigadorContratacao', 'InvestigadorAtividade', 'InvestigadorParticipacaoGestao', 'InvestigadorEntradaSaida', 'InvestigadorInstituicao', 'InvestigadorGrupoInvestigacao', 'GrauAcademico', 'TipoParticipacaoGestao', 'Instituicao', 'Categoria', 'Publicacao', 'PublicacaoService', 'PublicacaoAutor', 'RevistaEquipaEditorial', 'EventoOrganizacao', 'ProjetoEquipa', 'ProdutoInvestigador', 'Formacao', 'OrientacaoInvestigador', 'ServicoParticipante', 'Painel', 'Network', 'InvestigadorTooltip', 'GrupoInvestigacao'];
